import { useState, useEffect, useRef, forwardRef } from "react";

// SVG Icon components for each section
const SectionIcons = {
  intro: ({ size = 28, color = "#6366f1" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="20" fill={color + "18"} />
      <circle cx="24" cy="24" r="14" fill={color + "30"} />
      <path d="M24 10v14l10 6" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="24" cy="24" r="3" fill={color} />
      <circle cx="24" cy="10" r="2" fill={color} />
      <circle cx="36.1" cy="17" r="2" fill={color} />
      <circle cx="36.1" cy="31" r="2" fill={color} />
      <circle cx="24" cy="38" r="2" fill={color} />
      <circle cx="11.9" cy="31" r="2" fill={color} />
      <circle cx="11.9" cy="17" r="2" fill={color} />
    </svg>
  ),
  sql: ({ size = 28, color = "#0ea5e9" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <ellipse cx="24" cy="14" rx="16" ry="6" fill={color + "25"} stroke={color} strokeWidth="2" />
      <path d="M8 14v10c0 3.3 7.2 6 16 6s16-2.7 16-6V14" stroke={color} strokeWidth="2" />
      <path d="M8 24v10c0 3.3 7.2 6 16 6s16-2.7 16-6V24" stroke={color} strokeWidth="2" />
      <ellipse cx="24" cy="24" rx="16" ry="6" fill={color + "12"} />
      <ellipse cx="24" cy="34" rx="16" ry="6" fill={color + "08"} />
      <circle cx="32" cy="34" r="3" fill={color} opacity="0.6" />
      <path d="M30.5 33.5l3 3" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
  python: ({ size = 28 }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <path d="M23.5 6C16 6 16 10 16 10v4h8v2H13s-6-.5-6 7.5S12 37 12 37h3v-5s-.3-5.5 5-5.5h9s5 .3 5-4.5V12s.5-6-10.5-6z" fill="#3776AB" />
      <path d="M24.5 42C32 42 32 38 32 38v-4h-8v-2h11s6 .5 6-7.5S36 11 36 11h-3v5s.3 5.5-5 5.5h-9s-5-.3-5 4.5V36s-.5 6 10.5 6z" fill="#FFD43B" />
      <circle cx="20" cy="12.5" r="2" fill="white" opacity="0.9" />
      <circle cx="28" cy="35.5" r="2" fill="white" opacity="0.9" />
    </svg>
  ),
  ai: ({ size = 28, color = "#f43f5e" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      {/* Neural network: 3 layers of nodes with connections */}
      {/* Input layer */}
      <circle cx="8" cy="12" r="3.5" fill={color + "30"} stroke={color} strokeWidth="1.5" />
      <circle cx="8" cy="24" r="3.5" fill={color + "30"} stroke={color} strokeWidth="1.5" />
      <circle cx="8" cy="36" r="3.5" fill={color + "30"} stroke={color} strokeWidth="1.5" />
      {/* Hidden layer */}
      <circle cx="24" cy="10" r="3.5" fill={color + "40"} stroke={color} strokeWidth="1.5" />
      <circle cx="24" cy="24" r="4" fill={color} opacity="0.7" stroke={color} strokeWidth="1.5" />
      <circle cx="24" cy="38" r="3.5" fill={color + "40"} stroke={color} strokeWidth="1.5" />
      {/* Output layer */}
      <circle cx="40" cy="16" r="3.5" fill={color + "30"} stroke={color} strokeWidth="1.5" />
      <circle cx="40" cy="32" r="3.5" fill={color + "30"} stroke={color} strokeWidth="1.5" />
      {/* Connections input→hidden */}
      <line x1="11.5" y1="12" x2="20.5" y2="10" stroke={color} strokeWidth="0.8" opacity="0.4" />
      <line x1="11.5" y1="12" x2="20.5" y2="24" stroke={color} strokeWidth="0.8" opacity="0.3" />
      <line x1="11.5" y1="12" x2="20.5" y2="38" stroke={color} strokeWidth="0.8" opacity="0.2" />
      <line x1="11.5" y1="24" x2="20.5" y2="10" stroke={color} strokeWidth="0.8" opacity="0.3" />
      <line x1="11.5" y1="24" x2="20.5" y2="24" stroke={color} strokeWidth="0.8" opacity="0.5" />
      <line x1="11.5" y1="24" x2="20.5" y2="38" stroke={color} strokeWidth="0.8" opacity="0.3" />
      <line x1="11.5" y1="36" x2="20.5" y2="10" stroke={color} strokeWidth="0.8" opacity="0.2" />
      <line x1="11.5" y1="36" x2="20.5" y2="24" stroke={color} strokeWidth="0.8" opacity="0.3" />
      <line x1="11.5" y1="36" x2="20.5" y2="38" stroke={color} strokeWidth="0.8" opacity="0.4" />
      {/* Connections hidden→output */}
      <line x1="27.5" y1="10" x2="36.5" y2="16" stroke={color} strokeWidth="0.8" opacity="0.4" />
      <line x1="27.5" y1="10" x2="36.5" y2="32" stroke={color} strokeWidth="0.8" opacity="0.2" />
      <line x1="27.5" y1="24" x2="36.5" y2="16" stroke={color} strokeWidth="0.8" opacity="0.4" />
      <line x1="27.5" y1="24" x2="36.5" y2="32" stroke={color} strokeWidth="0.8" opacity="0.4" />
      <line x1="27.5" y1="38" x2="36.5" y2="16" stroke={color} strokeWidth="0.8" opacity="0.2" />
      <line x1="27.5" y1="38" x2="36.5" y2="32" stroke={color} strokeWidth="0.8" opacity="0.4" />
    </svg>
  ),
  bi: ({ size = 28, color = "#f59e0b" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <rect x="4" y="6" rx="3" width="40" height="30" fill={color + "15"} stroke={color} strokeWidth="2" />
      <rect x="8" y="22" width="5" height="10" rx="1" fill={color} opacity="0.5" />
      <rect x="15" y="16" width="5" height="16" rx="1" fill={color} opacity="0.65" />
      <rect x="22" y="19" width="5" height="13" rx="1" fill={color} opacity="0.5" />
      <rect x="29" y="12" width="5" height="20" rx="1" fill={color} opacity="0.8" />
      <rect x="36" y="14" width="5" height="18" rx="1" fill={color} opacity="0.65" />
      <path d="M10 27L17 21L24 24L31 15L38 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="24" cy="42" r="2" fill={color} opacity="0.7" />
      <path d="M18 38h12v2H18z" fill={color} opacity="0.3" />
    </svg>
  ),
  cloud: ({ size = 28, color = "#38bdf8" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <path d="M14 36h22a9 9 0 10-3-17.5A12 12 0 109 28h5" fill={color + "15"} />
      <path d="M14 36h22a9 9 0 10-3-17.5A12 12 0 109 28h5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M20 30l4-4 4 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24 26v12" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  excel: ({ size = 28, color = "#22c55e" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <rect x="6" y="6" rx="4" width="36" height="36" fill={color + "15"} stroke={color} strokeWidth="2" />
      <path d="M14 14l10 10M24 14L14 24" stroke={color} strokeWidth="3" strokeLinecap="round" />
      <rect x="28" y="14" width="8" height="3" rx="1" fill={color} opacity="0.5" />
      <rect x="28" y="20" width="8" height="3" rx="1" fill={color} opacity="0.4" />
      <rect x="28" y="26" width="8" height="3" rx="1" fill={color} opacity="0.3" />
      <rect x="14" y="28" width="8" height="3" rx="1" fill={color} opacity="0.3" />
      <rect x="14" y="34" width="22" height="3" rx="1" fill={color} opacity="0.2" />
    </svg>
  ),
  apps: ({ size = 28, color = "#8b5cf6" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="18" fill={color + "10"} stroke={color} strokeWidth="2" strokeDasharray="4 3" />
      <circle cx="24" cy="24" r="5" fill={color} opacity="0.7" />
      <circle cx="24" cy="8" r="4" fill={color + "40"} stroke={color} strokeWidth="1.5" />
      <circle cx="37" cy="16" r="4" fill={color + "40"} stroke={color} strokeWidth="1.5" />
      <circle cx="37" cy="32" r="4" fill={color + "40"} stroke={color} strokeWidth="1.5" />
      <circle cx="24" cy="40" r="4" fill={color + "40"} stroke={color} strokeWidth="1.5" />
      <circle cx="11" cy="32" r="4" fill={color + "40"} stroke={color} strokeWidth="1.5" />
      <circle cx="11" cy="16" r="4" fill={color + "40"} stroke={color} strokeWidth="1.5" />
      <path d="M24 12v8M28 22l7-4M28 26l7 4M24 28v8M20 26l-7 4M20 22l-7-4" stroke={color} strokeWidth="1.5" opacity="0.5" />
    </svg>
  ),
  stats: ({ size = 28, color = "#8b5cf6" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="20" fill={color + "12"} />
      <path d="M8 36 Q16 10 24 24 Q32 38 40 12" stroke={color} strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <circle cx="12" cy="28" r="2.5" fill={color} opacity="0.7" />
      <circle cx="24" cy="24" r="2.5" fill={color} opacity="0.7" />
      <circle cx="36" cy="16" r="2.5" fill={color} opacity="0.7" />
      <text x="24" y="44" textAnchor="middle" fill={color} fontSize="8" fontWeight="bold" opacity="0.6">σ</text>
    </svg>
  ),
  certs: ({ size = 28, color = "#14b8a6" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      {/* Ribbon tails */}
      <path d="M17 30l-5 14 6-3 3 5 4-12" fill={color} opacity="0.35" />
      <path d="M31 30l5 14-6-3-3 5-4-12" fill={color} opacity="0.35" />
      {/* Medal circle */}
      <circle cx="24" cy="22" r="14" fill={color + "18"} stroke={color} strokeWidth="2" />
      <circle cx="24" cy="22" r="9" fill={color + "30"} stroke={color} strokeWidth="1.5" />
      {/* Star in center */}
      <path d="M24 14l2.4 5 5.6.8-4 3.9 1 5.5L24 26.5l-5 2.7 1-5.5-4-3.9 5.6-.8z" fill={color} opacity="0.7" />
      {/* Top ring */}
      <ellipse cx="24" cy="7" rx="4" ry="2" fill={color + "40"} stroke={color} strokeWidth="1.2" />
    </svg>
  ),
};

const REVIEWS_COUNT = 7;

const SECTIONS_DATA = [
  {
    macro: "INTRODUZIONE",
    iconKey: "intro",
    color: "#6366f1",
    collections: [
      { name: "In che ordine seguire le raccolte della Scuola dei Dati", desc: "Un po' di consigli pratici per seguire al meglio i contenuti della Scuola dei Dati e un possibile piano di studio standard che puoi seguire. Possiamo ovviamente sentirci anche telefonicamente al 3207218062 per stilare un piano di studi personalizzato sulle tue esigenze.", lessons: [] },
      { name: "Studiare con l'AI: esempi con i chatbot e NotebookLM", desc: "Gli strumenti di intelligenza artificiale come i chatbot e NotebookLM possono essere un utile supporto nello studio.", lessons: ["Lezione 1: Primi passi con i chatbot","Lezione 2: Prompt per lo studio","Lezione 3: NotebookLM"] }
    ]
  },
  {
    macro: "DATABASE, SQL E DATAWAREHOUSE",
    iconKey: "sql",
    color: "#0ea5e9",
    collections: [
      { name: "Scrivere una query SQL", desc: "Impariamo da zero a scrivere correttamente una query SQL per interrogare efficacemente i dati di un Database relazionale", lessons: ["Lezione 1: Introduzione al concetto di Database","Lezione 2: Database relazionali","Lezione 3: RDBMS e linguaggio SQL","Lezione 4: Installare Sql Server Edizione Express","Lezione 5: Precisazione su errore in fase di connessione collegato ai certificati","Lezione 6: Selezionare e filtrare i dati - parte 1","Lezione 7: Selezionare e filtrare i dati: parte 2","Lezione 8: Raggruppare i dati - parte 1","Lezione 9: Raggruppare i dati - parte 2","Lezione 10: Combinare i dati di più tabelle - parte 1","Lezione 11: Combinare i dati di più tabelle - parte 2","Lezione 12: Attenzione agli errori nelle Join","Lezione 13: Join tra più tabelle e possibili problematiche","Esercitazione 1!","Lezione 14: Risolvere problemi complessi con Subquery e CTE","Lezione 15: Utilizzare Subquery per filtrare i dati","Lezione 16: Approfondimento sulla CASE WHEN","Lezione 17: Analisi esplorativa con SQL","Lezione 18: Condizioni di Join che coinvolgono i NULL – parte 1","Lezione 19: Condizioni di Join che coinvolgono i NULL – parte 2","Lezione 20: Le window function","Lezione 21: In che ordine valutare le clausole di una query","Esercitazione 2!"] },
      { name: "Creare e aggiornare un Database", desc: "Studiamo le istruzioni SQL per creare e aggiornare un database su Microsoft SQL Server", lessons: ["Lezione 1: Operazioni Delete, Update e Insert","Lezione 2: Introduzione a Commit e Rollback","Lezione 3: Creare tabelle e vincoli - parte 1","Lezione 4: Creare tabelle e vincoli - parte 2","Lezione 5: Popoliamo il database Cinematografia","Lezione 6: Inserimento da SQL Server Management Studio e ulteriori riflessioni sulle JOIN","Lezione 7: Popolare una tabella con i dati di un file csv","Lezione 8: Struttura del nome di una tabella su SQL Server","Lezione 9: Salvare e rieseguire il codice all'interno del database","Lezione 10: Esercizi sui vincoli dei database: parte 1","Lezione 11: Esercizi sui vincoli dei database - parte 2","Lezione 12: Normalizzazione di un database","Lezione 13: Operazioni DCL, creazione di un account di accesso su SQL Server","Esercitazione 1!","Lezione 14: Operazioni DCL, creazione di un utente di Database e istruzione Grant","Lezione 15: Operazioni DCL, Esempi con Revoke e Deny","Esercitazione 2 e Quiz!"] },
      { name: "Esercizi SQL", desc: "Tanti esercizi per consolidare i concetti più importanti della scrittura di query SQL", lessons: ["Lezione 1: Esercizi Select - From - Join - Where - Group By - Having","Lezione 2: Esercizi su un DB più complesso","Lezione 3: aumentiamo un po' la difficoltà","Lezione 4: confrontare i dati di più tabelle","Lezione 5: Subquery e CTE","Lezione 6: Esercizi più complessi"] },
      { name: "Progettare un Database e un DataWarehouse", desc: "Studiamo tutte le più importanti tecniche di progettazione di Database e DataWarehouse", lessons: ["Lezione 1: Database operazionali e analitici","Lezione 2: Gli step della progettazione","Lezione 3: Progettazione concettuale e diagramma E-R","Lezione 4: Progettazione logica di un database operazionale","Lezione 5: Normalizzazione di un database","Lezione 6: Progettazione fisica: implementazione del DB su SQL Server","Lezione 7: Approfondimenti sulle tabelle di SQL Server","Lezione 8: Progettazione fisica e indici","Lezione 9: Esercitazione parte 1: diagramma E-R","Lezione 10: Esercitazione parte 2: progettazione logica","Lezione 11: creazione database","Lezione 12: Diagramma E-R con specializzazioni","Esercitazione 1!","Lezione 13: Progettazione concettuale di un DataWarehouse","Lezione 14: Diagramma DFM","Lezione 15: Star schema e snowflake schema","Lezione 16: Esercitazione su classificazione in fatti e dimensioni","Lezione 17: Lettura di approfondimento: Slow Changing Dimension","Esercitazione 2 e Quiz!"] },
      { name: "Project Work SQL", desc: "Un Project Work completo per applicare quanto appreso sul linguaggio SQL e creare un portfolio personale", lessons: ["Lezione 1: Import dei dati","Lezione 2: Lavoriamo sui dati","Lezione 3: Effettuiamo l'analisi","Lezione 4: Miglioriamo la soluzione","Lezione 5: Creiamo un portfolio da Data Analyst","Lezione 6: Ripristino DB Adventure Works","Lezione 7: Skill fondamentali per uno sviluppatore SQL o Data Analyst","Lezione 8: Cancellazioni logiche e ragionamenti da fare","Lezione 9: Esplorazione del Database e Join tra tabelle","Lezione 10: Di nuovo sull'importanza del ragionamento","Lezione 11: prova a continuare tu!","Lezione 12: rieseguiamo le analisi su un DataWarehouse"] },
      { name: "Data Engineering e Data Architecture", desc: "Tutti i passaggi per implementare un'architettura a medaglione per passare dal dato grezzo a un DataWarehouse", lessons: ["Lezione 1: Introduzione al progetto, creazione e inserimento dei dati nel Bronze Layer","Lezione 2: Automatizziamo il caricamento del Bronze Layer con una stored procedure","Lezione 3: Creazione del Silver Layer","Lezione 4: Gestione di date e formati numerici nel Silver Layer","Lezione 5: Individuazione di un problema di chiavi duplicate","Lezione 6: Automatizziamo il caricamento del Silver Layer con una stored procedure","Lezione 7: Individuazione di misure e dimensioni del file","Lezione 8: Diagramma DFM e progettazione logica","Lezione 9: Creazione delle tabelle del Gold Layer","Lezione 10: Popoliamo la tabella DimCustomer","Lezione 11: Modifichiamo la progettazione aggiungendo la DimCity","Lezione 12: Popoliamo la tabella DimProduct","Lezione 13: Popoliamo la tabella dei fatti","Lezione 14: Automatizziamo il caricamento della DimCustomer con Update e Insert","Lezione 15: Gestione di un problema legato alla codifica del file","Lezione 16: Automatizziamo il caricamento della DimCity","Lezione 17: Automatizziamo il caricamento della DimProduct e Fact Sales","Lezione 18: Test delle procedure su un nuovo file","Lezione 19: Architettura dei dati","Lezione 20: Bronze, Silver e Gold Layer","Lezione 21: Lettura di approfondimento: introduzione al Data Lake","Lezione 22: Lettura di approfondimento: introduzione al Data Lakehouse","Project Work Data Engineering"] },
      { name: "T-SQL avanzato", desc: "Approfondiamo il T-SQL su Microsoft SQL Server tramite aspetti avanzati del linguaggio", lessons: ["Lezione 1: Variabili, viste parametriche e Apply","Lezione 2: Cross Apply e Outer Apply","Lezione 3: Window function","Lezione 4: Pivot e Unpivot dei dati","Lezione 5: Grouping sets - rollup - cube","Lezione 6: Transazioni e gestione degli errori - parte 1","Lezione 7: Transazioni e gestione degli errori - parte 2","Lezione 8: Transazioni e gestione degli errori - parte 3","Lezione 9: Chiavi primarie, indici clustered e indici non clustered","Lezione 10: Fattori che influenzano l'utilizzo di un indice non clustered","Lezione 11: Machine Learning con T-SQL, parte 1","Lezione 12: Machine Learning con T-SQL, parte 2","Lezione 13: Machine Learning con T-SQL, parte 3"] },
      { name: "SQL e PL-SQL su Oracle", desc: "Approfondiamo SQL e PL-SQL per la programmazione sui Database Oracle", lessons: ["Lezione 1: Oracle Live SQL","Lezione 2: Prime differenze tra Sql Server e Oracle","Lezione 3: Differenze sul tipo date","Lezione 4: Differenze tra le transazioni","Lezione 5: Creiamo il primo blocco PL-SQL anonimo","Lezione 6: Blocco exception","Lezione 7: Creiamo una stored procedure","Lezione 8: Eseguiamo stored procedure con parametri di output","Lezione 9: Miglioriamo il codice","Lezione 10: Errori custom","Lezione 11: Creare e usare una funzione","Lezione 12: Package","Lezione 13: Variabili di tipo record","Lezione 14: Cicli in PL-SQL","Lezione 15: Come dichiarare e utilizzare un cursore","Lezione 16: Cursori parametrici","Lezione 17: Il blocco procedurale case when","Lezione 18: Funzioni per la gestione delle stringhe","Lezione 19: Funzioni per la gestione delle date","Lezione 20: Variabili e blocchi annidati","Lezione 21: Il tipo pls_integer","Lezione 22: Come eseguire codice PL-SQL dinamico"] },
      { name: "SQL in ambiente MySQL e PostgreSQL", desc: "Approfondiamo il linguaggio SQL in ambiente MySQL e PostgreSQL", lessons: ["Lezione 1: Installazione MySQL","Lezione 2: Differenze con MySQL – parte 1","Lezione 3: Differenze con MySQL – parte 2","Lezione 4: Differenze con MySQL – parte 3","Lezione 5: Differenze con MySQL – parte 4","Lezione 6: Lettura di approfondimento: update con JOIN","Lezione 7: Installazione PostgreSQL e PgAdmin4","Lezione 8: Creiamo un Database d'esempio su PostgreSQL","Lezione 9: Differenze con PostgreSQL – parte 1","Lezione 10: Differenze con PostgreSQL – parte 2","Lezione 11: Differenze con PostgreSQL – parte 3","Lezione 12: Differenze con PostgreSQL – parte 4"] },
      { name: "Performance tuning avanzato di SQL Server e SQL Azure", desc: "Raccolta di approfondimento su temi avanzati legati al tuning delle performance di SQL Server e SQL Azure", lessons: ["Lezione 1: Chiavi primarie e indici clustered","Lezione 2: Indici non clustered","Lezione 3: Fattori che influenzano l'utilizzo di un indice non clustered","Lezione 4: Operazioni di ordinamento e rimozioni duplicati","Lezione 5: Algoritmi di join","Lezione 6: Covered index e indici multi-colonna","Lezione 7: Importanza dell'ordine delle colonne in un clustered index","Lezione 8: Sperimentiamo come cambia il QEP al variare degli indici","Lezione 9: Fattori che non influiscono sul piano d'esecuzione","Lezione 10: Approfondimento T-SQL: conversioni di tipo","Lezione 11: Sostituire quando possibile UNION con UNION ALL","Lezione 12: Utilizzare la clausola GROUPING SETS","Lezione 13: Confronto tra LEFT JOIN e NOT EXISTS","Lezione 14: Condizioni Sargable","Lezione 15: Utilizzo di tabelle temporanee","Lezione 16: Analisi delle performance delle Window function – esempio 1","Lezione 17: Analisi delle performance delle Window function – esempio 2","Lezione 18: Migliorare le performance tramite un pre-raggruppamento","Lezione 19: Riflessioni sull'utilizzo di viste","Lezione 20: Tuning con tabelle temporanee e SQL dinamico","Lezione 21: Ottimizziamo una query strana con l'operatore IN","Lezione 22: Left join vs Inner Join","Lezione 23: Trova l'indice giusto","Lezione 24: Aggiungiamo una join per utilizzare al meglio un indice","Lezione 25: Cercare proattivamente le query più problematiche","Lezione 26: Warning nei piani d'esecuzione e approfondimento sulle statistiche"] },
    ]
  },
  {
    macro: "PROGRAMMAZIONE IN PYTHON",
    iconKey: "python",
    color: "#10b981",
    collections: [
      { name: "Fondamenti di Python", desc: "Studiamo bene tutti i concetti fondamentali della programmazione in Python propedeutici all'utilizzo del linguaggio per l'analisi dei dati e l'intelligenza artificiale.", lessons: ["Lezione 1: Installazione Python e Jupyter","Lezione 2: Tutto è un oggetto!","Lezione 3: Il primo oggetto mutabile, le liste","Lezione 4: Approfondimento sulle liste","Lezione 5: Gli insiemi","Lezione 6: I dizionari","Esercitazione 1!","Lezione 7: Istruzione IF","Lezione 8: Istruzione While","Lezione 9: Istruzioni break e continue","Lezione 10: Istruzione for","Esercitazione 2!","Lezione 11: Metodi per le liste - parte 1","Lezione 12: Metodi per le liste - parte 2","Lezione 13: Metodi per le liste - parte 3","Lezione 14: List comprehension","Lezione 15: Esercizi sulle liste","Lezione 16: Metodi per le tuple","Lezione 17: Metodi per i set","Lezione 18: Metodi per i dizionari - parte 1","Lezione 19: Metodi per i dizionari - parte 2","Lezione 20: Liste di dizionari","Lezione 21: Esercizi su liste di dizionari","Lezione 22: F-string","Lezione 23: Metodi per le stringhe","Esercitazione 3!"] },
      { name: "Programmazione in Python", desc: "Approfondiamo i temi della programmazione in Python, studiando le funzioni, il paradigma della programmazione a oggetti e preparandoci alla certificazione PCEP", lessons: ["Lezione 1: Conversione di tipi e gestione di stringhe csv","Lezione 2: Introduzione alle funzioni","Lezione 3: Funzioni con più parametri in input e in output","Lezione 4: Visibilità degli oggetti","Lezione 5: Approfondimenti sulle funzioni","Lezione 6: Un caso molto particolare con i parametri di default","Lezione 7: Funzione lambda","Lezione 8: Funzione args e kwargs","Programmazione in Python - Esercitazione 1!","Lezione 9: Gestione degli errori e blocco try-except","Lezione 10: Value Type e Type Error","Lezione 11: Divisione per zero e concetti di clean code","Lezione 12: Altre tipologie di eccezioni","Lezione 13: Gestire più eccezioni e usare raise","Lezione 14: Dal file ipynb al file py","Lezione 15: Linguaggi compilati e interpretati","Lezione 16: Primi passi nella programmazione a oggetti","Lezione 17: Esercitiamoci creando una nuova classe","Lezione 18: Metodi str e repr","Lezione 19: Documentazione di una classe","Lezione 20: Continuiamo ad esercitarci sulla classe Persona","Lezione 21: Il concetto di ereditarietà","Lezione 22: Esercitazioni sull'ereditarietà","Programmazione in Python - Project Work!"] },
      { name: "Import dei dati e API con Python", desc: "Utilizziamo Python e Pandas, SQLAlchemy, Pymongo e Requests per importare dati da varie fonti", lessons: ["Lezione 1: Import di file CSV","Lezione 2: Caratteristiche dei DataFrame","Lezione 3: Import di file Excel","Lezione 4: Import di file JSON","Lezione 5: Importiamo un nuovo file CSV più complesso","Esercitazione 1!","Lezione 6: Importante precisazione sulla crittografia dei dati","Lezione 7: Leggere con Python dei dati da SQL Server","Lezione 8: Scrivere con Python dati su SQL Server","Lezione 9: Approfondimento sulla connessione tra Python e SQL Server","Lezione 10: Leggere con Python dei dati da MongoDb","Lezione 11: Scrivere con Python dati su MongoDB","Lezione 12: Paradigma ETL: dal file al database tramite Python","Lezione 13: API con Python – la libreria requests","Lezione 14: Un esempio di libreria per chiamare un'API specifica","Esercitazione 2!"] },
      { name: "Analisi dei dati con Python e Pandas", desc: "Studiamo la libreria Pandas per operazioni di analisi dei dati precise e performanti", lessons: ["Lezione 1: Organizzare il codice in funzioni","Lezione 2: Filtrare i dati - parte 1","Lezione 3: Filtrare i dati - parte 2","Lezione 4: Aggiornamento: filtrare i dati con il metodo query","Lezione 5: Aggregare i dati - metodo groupby - parte 1","Lezione 6: Aggregare i dati – metodo groupby – parte 2","Lezione 7: Combinare i dati - metodo merge","Lezione 8: Combinare i dati - metodo concat","Lezione 9: Ordinare i dati e modificare la struttura di un DataFrame","Lezione 10: Modificare e trasformare i dati in un DataFrame","Lezione 11: Visualizzare i dati senza duplicati","Esercitazione 1!","Lezione 12: Pivot e unpivot dei dati","Lezione 13: Conversione di stringhe in liste e metodo explode","Esercitazione 2!"] },
      { name: "Python per la finanza", desc: "Applichiamo i concetti imparati finora all'analisi di un portafoglio finanziario", lessons: ["Lezione 1: Acquisizione dei dati","Lezione 2: Calcolo asset allocation","Lezione 3: Controlli di qualità e merge dei dati","Lezione 4: Regole per il calcolo dei rendimenti","Lezione 5: Calcolo rendimenti con Python","Lezione 6: Rappresentazione grafica dei rendimenti","Lezione 7: Rendimento del portafoglio","Lezione 8: Calcolo della volatilità","Lezione 9: Rappresentiamo la volatilità","Lezione 10: Calcolo della correlazione","Lezione 11: Rappresentazione grafica della correlazione tra gli asset"] },
      { name: "Programmazione a oggetti con Python", desc: "Studiamo il paradigma di programmazione a oggetti con il linguaggio Python", lessons: ["Lezione 1: Primi passi nella programmazione a oggetti","Lezione 2: Esercitiamoci creando una nuova classe","Lezione 3: metodi str e repr","Lezione 4: Documentazione di una classe","Lezione 5: continuiamo ad esercitarci sulla classe Persona","Lezione 6: il concetto di ereditarietà","Lezione 7: esercitazioni sull'ereditarietà"] },
      { name: "Esercitazione Python e Pandas per il pre-processing", desc: "Applichiamo Pandas alle tecniche di pre-processing del Machine Learning", lessons: ["Lezione 1: Import del file Iris","Lezione 2: Filtrare e ordinare i dati di Iris","Lezione 3: Gestire i null - parte 1","Lezione 4: Gestire i null - parte 2","Lezione 5: Gestione variabile target e suddivisione in training e test","Lezione 6: Valorizzazione null","Lezione 7: Normalizzazione dati","Lezione 8: Aggiunta colonna e conversione dati in array di numpy"] },
    ]
  },
  {
    macro: "STATISTICA, MATEMATICA E DATA SCIENCE",
    iconKey: "stats",
    color: "#8b5cf6",
    collections: [
      { name: "Statistica descrittiva a una variabile", desc: "I principali indici di statistica descrittiva con Excel, SQL, Python e R", lessons: ["Lezione 1: introduzione generale","Lezione 2: Classificazione delle variabili statistiche","Lezione 3: indici di posizione centrale","Lezione 4: indici di variabilità","Lezione 5: Outlier e coefficiente di variazione","Lezione 6: Un'ulteriore procedura di calcolo per la varianza","Lezione 7: Grafici per la statistica monovariata","Lezione 8: Calcolo degli indici con Excel","Lezione 9: Grafici con Excel","Lezione 10: Calcolo degli indici con SQL","Lezione 11: Calcolo degli indici con Python","Lezione 12: Installazione di R e R studio","Lezione 13: Creiamo un ambiente in R","Lezione 14: Primi passi con R studio","Lezione 15: Calcolo degli indici con R","Lezione 16: Approfondimento per il ML: scaling di una variabile","Lezione 17: Indici di forma per una variabile","Lezione 18: Scaling e indici di forma con SQL","Lezione 19: Scaling e indici di forma con Python","Lezione 20: Scaling e indici di forma con R","Lezione 21: Variabilità per variabili qualitative: indice di eterogeneità di Gini","Lezione 22: Indice di eterogeneità di Gini con R","Esercitazione!"] },
      { name: "Statistica descrittiva a più variabili", desc: "Le relazioni tra due o più variabili con Excel, SQL, Python e R", lessons: ["Lezione 1: Indici Chi quadrato e V di Cramer","Lezione 2: Indici Chi quadrato e V di Cramer con SQL","Lezione 3: Indici Chi quadrato e V di Cramer con Python","Lezione 4: Indici Chi quadrato e V di Cramer con R","Lezione 5: Indice Eta Quadro","Lezione 6: Indice Eta quadro con SQL","Lezione 7: Indice Eta quadro con Python","Lezione 8: Indice eta quadro con R","Lezione 9: Analisi bivariata e covarianza","Lezione 10: Coefficiente di correlazione di Pearson","Lezione 11: Grafico a dispersione","Lezione 12: Coefficiente di Spearman","Lezione 13: Covarianza e regressione con SQL","Lezione 14: Covarianza e regressione con Python","Lezione 15: Covarianza e regressione con R","Lezione 16: Analisi esplorativa dei dati","Lezione 17: Rappresentazioni grafiche con Seaborn"] },
      { name: "Statistica inferenziale con R e Python", desc: "Generalizziamo i risultati al di fuori del campione con la statistica inferenziale", lessons: ["Lezione 1: introduzione","Lezione 2: Stime puntuali","Lezione 3: Distribuzione normale e test di Shapiro","Lezione 4: Distribuzione normale e test di Shapiro con R","Lezione 5: Intervallo di fiducia per la media con Python","Lezione 6: Intervallo di fiducia per la media con R","Lezione 7: Approfondimento sugli intervalli di fiducia","Lezione 8: Intervallo di fiducia per varianza e deviazione standard","Lezione 9: Intervallo di fiducia per varianza con R","Lezione 10: Test sulla media con Python","Lezione 11: Test sulla media con R","Lezione 12: T test per due campioni indipendenti","Lezione 13: T test per due campioni indipendenti con R","Lezione 14: T test per due campioni dipendenti","Lezione 15: T test per due campioni dipendenti con R","Quiz!"] },
      { name: "Idee matematiche per l'AI", desc: "Le idee matematiche di base dietro gli algoritmi di Machine Learning", lessons: ["Lezione 1: Esempio di problema risolvibile con l'AI","Lezione 2: Algoritmo K-neighbors","Lezione 3: Entriamo nel dettaglio matematico","Lezione 4: Passiamo a 3 e a più dimensioni","Lezione 5: Algoritmo Perceptron di Rosenblatt","Lezione 6: Similitudine con il neurone umano","Lezione 7: trilioni di parametri!","Lezione 8: Introduzione agli LLM","Lezione 9: Temperatura degli LLM","Lezione 10: Tokenizzazione dell'input","Lezione 11: Embedding del testo","Lezione 12: Architettura Transformer e generazione dell'output","Lezione 13: Ripasso LLM e introduzione ai vettori","Lezione 14: Somme e sottrazioni tra vettori","Lezione 15: Introduzione a Numpy","Lezione 16: Prodotto scalare","Lezione 17: Interpretazione prodotto scalare - parte 1","Lezione 18: Interpretazione prodotto scalare - parte 2","Lezione 19: Interpretazione prodotto scalare - parte 3","Lezione 20: Implementazione con Numpy"] },
      { name: "Machine Learning con Python", desc: "Implementiamo da zero e con scikit-learn i principali algoritmi di ML", lessons: ["Lezione 1: Implementazione del Perceptron - parte 1","Lezione 2: Implementazione del Perceptron - parte 2","Lezione 3: Perceptron e OOP - parte 1","Lezione 4: Perceptron e OOP - parte 2","Lezione 5: Perceptron e OOP - parte 3","Lezione 6: Algoritmo di discesa stocastica del gradiente","Lezione 7: Regressione Logistica","Lezione 8: K-neighbours – parte 1","Lezione 9: K-neighbours – parte 2","Lezione 10: Preprocessing con Scikit-Learn","Lezione 11: ML con Scikit-Learn - parte 2","Lezione 12: ML sul dataset Titanic – studio delle variabili","Lezione 13: ML sul dataset Titanic – encoding e normalizzazione","Lezione 14: Pipeline e convalida k-fold","Lezione 15: Ottimizzazione dei parametri","Lezione 16: Matrice di confusione","Lezione 17: Creiamo un portfolio da Data Scientist","Project Work!"] },
      { name: "Regressione, clustering e reti neurali", desc: "Algoritmi di riconoscimento immagini, regressione e clustering", lessons: ["Lezione 1: Introduzione alle reti neurali","Lezione 2: Reti neurali per classificazione di immagini","Lezione 3: Introduzione alla regressione","Lezione 4: Pre-processing del dataset Diamonds","Lezione 5: Algoritmi di regressione lineare","Lezione 6: K-n Regressor e analisi dei residui","Lezione 7: Clustering dei dati","Quiz!"] },
    ]
  },
  {
    macro: "INTELLIGENZA ARTIFICIALE OLTRE I CHATBOT: AI ENGINEERING",
    iconKey: "ai",
    color: "#f43f5e",
    collections: [
      { name: "Interazioni tra Python e LLM", desc: "Entriamo nel mondo degli LLM e della loro interazione con Python", lessons: ["Lezione 1: Installare Ollama e scaricare Mistral","Lezione 2: Configurare un ambiente virtuale","Lezione 3: Prime interazioni con Ollama","Lezione 4: Pandas Query Engine con Llama index","Lezione 5: Generare codice Pandas tramite Ollama","Lezione 6: Interrogare un PDF con Llama index","Lezione 7: Retrieval Augmented Generation","Lezione 8: Interagire con GPT tramite API","Lezione 9: ChatBOT per generare codice Pandas","Lezione 10: Un esempio più complesso con due file","Lezione 11: Interrogare un PDF tramite API di GPT","Lezione 12: Vector store index su più file","Lezione 13: Introduzione al passaggio del contesto","Lezione 14: Chatbot avanzato con gestione della memoria"] },
      { name: "Agenti AI con LangChain", desc: "Prompt engineering, DB vettoriali, RAG e agenti AI con LangChain", lessons: ["Lezione 1: Chiamate agli LLM con LangChain","Lezione 2: La nostra prima catena di linguaggio","Lezione 3: gestione dell'output","Lezione 4: funzioni custom per generazione di CSV","Lezione 5: gestione della memoria","Lezione 6: acquisizione PDF e metadati","Lezione 7: creazione e popolazione di un DB vettoriale","Lezione 8: Query sul DB vettoriale","Lezione 9: Formattazione dell'output","Lezione 10: Interazione tra RAG e LLM","Lezione 11: Agenti AI","Lezione 12: Importanza del prompt"] },
      { name: "Claude Code: Skill e Spec Driven Development per la Data Analysis", desc: "Impariamo a utilizzare il rivoluzionario assistente alla scrittura di codice su progetti di Data Analysis, creando skill dedicate e applicando i principi dello Spec Driven Development", lessons: ["Lezione 1: Cos'è Claude Code","Lezione 2: Primi Esperimenti con Claude Code","Lezione 3: Esploriamo Dati in Cartelle Esterne","Lezione 4: File Settings.json","Lezione 5: Creazione di un Grafico con Seaborn","Lezione 6: L'Importanza del File CLAUDE.md","Lezione 7: Le Skill - Parte 1","Lezione 8: Le Skill - Parte 2","Lezione 9: Le Skill - Parte 3","Lezione 10: \"Prompt Mediocre\"","Lezione 11: \"Prompt Buono\"!","Lezione 12: \"Prompt Ottimo\"!","Lezione 13: Modalità Pianificazione","Lezione 14: Spec Driven Development: Introduzione","Lezione 15: Spec Driven Development: Specifiche e Skill","Lezione 16: Spec Driven Development: in azione!"] },
      { name: "Agenti AI per la Data Analysis", desc: "Uniamo Python, LangChain, Claude Opus, Claude Code e le conoscenze di Data Analysis per testare le capacità degli agente AI, utilizzarli in maniera professionale e non cadere nelle trappole più comuni.", lessons: ["Lezione 1: Importanti considerazioni sulla privacy e creazione login su SQL Server","Lezione 2: Approccio senza connessione al DB","Lezione 3: Perché i risultati sono diversi?","Lezione 4: Primi esperimento con l'agente SQL","Lezione 5: Impatto del prompt","Lezione 6: Analisi della richiesta fatta da me","Lezione 7: Analisi della richiesta fatta dall'agente","Lezione 8: Introduzione alle performance delle query","Lezione 9: Primo esperimento con LangChain","Lezione 10: Secondo esperimento con LangChain","Lezione 11: Osservazione sulla query per individuare gli indici","Lezione 12: Primi esperimenti con Claude Code","Lezione 13: Tuning di query con Claude Code - pt 1","Lezione 14: Tuning di query con Claude Code - pt 2","Lezione 15: Tuning di query con Claude Code - pt 3","Lezione 16: Lettura di approfondimento - Cosa succede quando chiedo a un'AI di analizzare un file?","Lezione 17: Attenzione ai formati!","Lezione 18: Rappresentazioni grafiche"] },
      { name: "Agenti AI per la Data Science", desc: "Eseguiamo da zero un progetto di Machine Learning introducendo progressivamente l'utilizzo dell'AI, da supporto alla scrittura di codice all'utilizzo agentico tramite Claude Code", lessons: ["Lezione 1: Prime analisi del file parkinson_data","Lezione 2: Capiamo il problema da affrontare","Lezione 3: Analisi statistiche e grafiche","Lezione 4: Spiegazione del codice generato da Claude","Lezione 5: Analisi bivariata","Lezione 6: Divisione training e test","Lezione 7: Scaling dei dati","Lezione 8: Algoritmo di Machine Learning","Lezione 9: Nuovo algoritmo di trasformazione","Lezione 10: Convalida incrociata k fold","Lezione 11: No free lunch theorem","Lezione 12: Creazione di un prompt per il chatbot di Claude","Lezione 13: Analisi del codice restituito da Claude","Lezione 14: Eseguiamo il codice generato - parte 1","Lezione 15: Eseguiamo il codice generato - parte 2","Lezione 16: Passiamo su Claude Code! File md e prompt per pianificazione","Lezione 17: Analisi della pianificazione di Claude Code","Lezione 18: Qualche intoppo in fase di esecuzione","Lezione 19: Risultati ottenuti"] },
      { name: "Creiamo un Chatbot con l'AI", desc: "Vediamo da zero tutti i passaggi per creare un Chatbot sui nostri file PDF in locale tramite l'intelligenza artificiale e la libreria LangChain di Python", lessons: ["Lezione 1: Test del modello in locale e configurazione Google Colab","Lezione 2: Acquisizione dei PDF e creazione database vettoriale","Lezione 3: Creazione degli embedding e caricamento dei vettori nel database","Lezione 4: Query NoSQL sul database vettoriale","Lezione 5: Creazione del retriever e passaggio del contesto al modello LLM","Lezione 6: Modifica del prompt di sistema"] },
      { name: "Genetica e Intelligenza Artificiale", desc: "Un algoritmo di AI basato sulle leggi della genetica", lessons: ["Lezione 1: Introduzione e algoritmo genetico","Lezione 2: Acquisizione del file e generazione di un individuo","Lezione 3: Funzione per generare una nuova famiglia","Lezione 4: Composizione di una lista di famiglie casuali","Lezione 5: Estrarre le famiglie migliori","Lezione 6: Creazione di una famiglia discendente","Lezione 7: Programma principale ed esecuzione"] }
    ]
  },
  {
    macro: "EXCEL",
    iconKey: "excel",
    color: "#22c55e",
    collections: [
      { name: "Primi passi con Excel", desc: "Iniziamo dalle basi il percorso per diventare utenti esperti di Excel", lessons: ["Lezione 1: Come inserire i dati in un foglio Excel","Lezione 2: Perché usare Excel","Lezione 3: L'importanza dei dati in tabelle","Lezione 4: Selezione di celle e annullamento","Lezione 5: Prime operazioni di formattazione","Lezione 6: Creazione di un grafico","Lezione 7: Salvataggio","Lezione 8: Altri fogli elettronici disponibili","Esercitazione!"] },
      { name: "Le funzioni più utili di Excel", desc: "Impariamo a utilizzare le funzioni di Excel più utili e diffuse", lessons: ["Lezione 1: Introduzione a formule e funzioni","Lezione 2: Funzioni SOMMA, SOMMA.SE e statistiche","Lezione 3: Funzioni di tipo Testo","Lezione 4: Funzioni logiche","Lezione 5: Cerca Verticale e Cerca X","Lezione 6: Percentuali e arrotondamenti","Lezione 7: Funzioni Database","Lezione 8: Approfondimento funzioni logiche","Lezione 9: Funzione Testo Unisci","Lezione 10: Funzione Subtotale","Lezione 11: Funzione Scarto","Lezione 12: Funzione Indiretto","Lezione 13: Funzione unici","Lezione 14: Funzioni Filtro, Dati Ordina e Sequenza","Lezione 15: Gestione delle date nella funzione Filtro","Lezione 16: Funzione Filtro con condizioni And e Or","Lezione 17: Gestione delle stringhe vuote","Lezione 18: Interazioni tra funzioni e tabelle","Esercitazione!"] },
      { name: "Tabelle Pivot Excel", desc: "Dalle basi agli aspetti più avanzati delle Tabelle Pivot", lessons: ["Lezione 1: come e perché creare una tabella Pivot","Lezione 2: creiamo un grafico Pivot","Lezione 3: filtri e aggiornamento dei dati","Lezione 4: elaboriamo i dati di partenza","Lezione 5: analisi su più dimensioni","Lezione 6: Approfondimenti sui filtri delle Pivot","Lezione 7: layout e raggruppamenti nelle Pivot","Lezione 8: Campi calcolati","Lezione 9: Formule su tabelle Pivot","Lezione 10: Conflitti tra campi calcolati e raggruppati","Lezione 11: Modello Dati","Lezione 12: Aggiornamento tramite tabelle","Lezione 13: Calcolo degli scostamenti percentuali","Lezione 14: Creazione di Dashboard","Lezione 15: Miglioriamo graficamente la Dashboard","Lezione 16: Creiamo un portfolio progetti per Excel","Project Work!"] },
      { name: "Approfondimenti Excel", desc: "Partiamo da degli esercizi di riepilogo e arriviamo a trattare approfondimenti via via più complessi", lessons: ["Lezione 1: Funzionalità di base e formule","Lezione 2: Formattazione condizionale e stampa","Lezione 3: Cerca vert e funzioni logiche","Lezione 4: Tabelle pivot","Lezione 5: Esercitazione Data Visualization - parte 1: presentazione problema","Lezione 6: Esercitazione Data Visualization - parte 2: data storytelling","Lezione 7: Esercitazione Data Visualization - parte 3: scelta grafico per ranking","Lezione 8: Esercitazione Data Visualization - parte 4: grafico a barre orizzontali","Lezione 9: Esercitazione Data Visualization - parte 5: pericoli del copia & incolla","Lezione 10: Esercitazione Data Visualization - parte 6: ora continua tu!","Lezione 11: Formula RaggruppaPer","Lezione 12: Confronto con Tabelle Pivot","Lezione 13: Entriamo nel dettaglio del processo di aggiornamento","Lezione 14: Cos'è davvero un file Excel","Lezione 15: Confrontiamo vari approcci e introduciamo Power Query","Lezione 16: Formula Lambda","Lezione 17: Considerazione sui grafici","Lezione 18: RaggruppaPer e PivotPer","Lezione 19: Esercizio Data Analysis","Lezione 20: Funzione LET","Lezione 21: Formule matrice dinamica e tabella","Lezione 22: Python in Excel"] },
      { name: "Excel e Power Query", desc: "Import e lavorazione dei dati con Power Query", lessons: ["Lezione 1: Import e lavorazione dei dati","Lezione 2: Combinazione di query","Lezione 3: Creazione dell'output finale","Lezione 4: Unpivot con Power Query","Lezione 5: Raggruppamenti di testo","Lezione 6: Gestione degli errori su Power BI","Lezione 7: Import multipli da un singolo file Excel","Project Work!","Lezione 8: Acquisizione di più file da una cartella","Lezione 9: Modifiche sul file d'esempio","Lezione 10: Risoluzione di un errore nel file d'esempio","Lezione 11: Individuazione dei calciatori che hanno cambiato competizione","Lezione 12: Filtri e operazioni sul ruolo dei calciatori","Lezione 13: Considerazioni sulla sicurezza in Power Query","Esercitazione!"] },
      { name: "Excel e Power Pivot", desc: "Analizziamo lo strumento evoluto di Business Intelligence Power Pivot disponibile all'interno di Excel, analizzando analogie e differenze con le classifiche tabelle Pivot e il potente linguaggio DAX", lessons: ["Lezione 1: Prime differenze e analogie tra Pivot e Power Pivot","Lezione 2: Formule su Tabelle Pivot","Lezione 3: Esempi risolvibili (e non risolvibili) sui dati di input","Lezione 4: Creazione di una misura DAX con Power Pivot","Lezione 5: Calcolo della mediana con DAX","Lezione 6: Introduzione a Power BI","Lezione 7: \"Conteggio\" e \"Conteggio distinti\"","Lezione 8: Possibili criticità nell'uso dei filtri","Lezione 9: Interazione con Claude e insidie nel DAX","Lezione 10: Power Pivot e \"Cambio origine dati\""] },
      { name: "Excel, Macro e VBA", desc: "Macro e VBA per automatizzare operazioni in Excel", lessons: ["Lezione 1: Introduzione a Macro e VBA","Lezione 2: Riflessioni sull'utilizzo del VBA","Lezione 3: Creiamo la nostra prima macro","Lezione 4: Analizziamo il codice VBA","Lezione 5: Primi miglioramenti al codice","Lezione 6: Variabili e oggetti","Lezione 7: Istruzione IF per gestire i filtri","Lezione 8: Creiamo da zero una nuova Macro","Quiz!"] },
      { name: "Copilot in Excel", desc: "Eseguiamo una serie di compiti con Copilot, analizzandone il comportamento anche in casi particolari come la presenza di righe vuote, spazi, numeri non formattati correttamente, eccetera", lessons: ["Lezione 1: primi passi con Copilot","Lezione 2: test con file Excel dalla struttura disordinata","Lezione 3: altri test in situazioni complesse","Lezione 4: spazi e caratteri speciali nelle celle","Lezione 5: Esperimenti con Cerca Vert e Cerca X"] }
    ]
  },
  {
    macro: "POWER BI",
    iconKey: "bi",
    color: "#f59e0b",
    collections: [
      { name: "Power BI e Power Query", desc: "Business Intelligence a 360 gradi con Power BI", lessons: ["Lezione 1: Installazione di PowerBI Desktop","Lezione 2: Import dei dati","Lezione 3: Creazione della Dashboard","Lezione 4: Formattazione e interazione","Lezione 5: Gestione degli errori: parte 1","Lezione 6: Gestione degli errori: parte 2","Lezione 7: Import numeri e date - parte 1","Lezione 8: Import numeri e date – parte 2","Lezione 9: Import multipli da un singolo file Excel","Lezione 10: Trasformare i dati con Power Query","Lezione 11: Approfondimento Dividi colonna","Lezione 12: Calcolare nuove colonne","Lezione 13: Unire il contenuto di più file","Lezione 14: Raggruppare e filtrare i dati","Lezione 15: Creare relazioni tra tabelle","Lezione 16: Dashboard su più tabelle","Lezione 17: Formule DAX: Datediff e IF","Lezione 18: Analisi grafica e matriciale","Lezione 19: Utilizzo dei grafici","Lezione 20: Creare relazioni su più colonne","Lezione 21: Elaborazione di un file e pivot","Lezione 22: Merge tra due file","Project Work!"] },
      { name: "Power BI e DAX", desc: "Approfondiamo DAX per il calcolo di KPI anche molto complessi", lessons: ["Lezione 1: Colonne calcolate con DAX","Lezione 2: Tabelle calcolate con DAX","Lezione 3: Da misura implicita a esplicita","Lezione 4: Da colonna calcolata a misura","Lezione 5: Funzione SUMX","Lezione 6: Contesto di filtro","Lezione 7: KPI per cui è obbligatoria la misura","Lezione 8: il contesto di filtro tra le relazioni","Lezione 9: direzione delle relazioni e contesto di riga","Lezione 10: Funzione Filter in SUMX","Lezione 11: Misure simili con risultati diversi","Lezione 12: All e Allselected","Lezione 13: All di una colonna","Lezione 14: interazione tra misure e contesti - parte 1","Lezione 15: interazione tra misure e contesti - parte 2","Lezione 16: la funzione Calculate","Lezione 17: modifiche del contesto con Calculate","Lezione 18: Calculate per range temporali","Lezione 19: Importi cumulati con Calculate","Lezione 20: Funzioni di Time intelligence","Lezione 21: Transizioni di contesto con Calculate","Lezione 22: Funzioni DAX per le date","Lezione 23: Funzioni DAX per le stringhe","Project Work!"] },
      { name: "Power BI e Modello dati", desc: "Best practice di modellizzazione dei dati nel modello a stella", lessons: ["Lezione 1: Vari esempi di modello dei dati","Lezione 2: Fatti, dimensioni e misure","Lezione 3: scelta del fatto e analisi della granularità","Lezione 4: individuazione di dimensioni e misure","Lezione 5: setup del file pbix","Lezione 6: Creazione della DimProduct","Lezione 7: Creazione della DimTerritory","Lezione 8: Lavoriamo sulla OrderHeaders","Lezione 9: Creazione FactOrders e relazioni","Lezione 10: Creazione della DimDate con DAX","Project Work!"] },
      { name: "Visualizzazioni avanzate in Power BI", desc: "Visualizzazioni avanzate e miglioramento grafico delle Dashboard", lessons: ["Lezione 1: Navigare con il Drill-through","Lezione 2: Grafici a nastro","Lezione 3: Alberi di scomposizione","Lezione 4: Grafici di dispersione","Lezione 5: Miglioriamo le Dashboard – parte 1","Lezione 6: Miglioriamo le Dashboard – parte 2","Lezione 7: Miglioriamo le Dashboard – parte 3","Lezione 8: Creiamo un portfolio da Data Analyst","Project Work e Quiz!"] },
      { name: "Power BI Service", desc: "Studiamo l'interazione di Power BI con il cloud!", lessons: ["Power BI Service: pubblicazione di report, condivisione di aree di lavoro e creazione di app"] }
    ]
  },
  {
    macro: "IL CLOUD",
    iconKey: "cloud",
    color: "#38bdf8",
    collections: [
      { name: "Data Analysis in Cloud", desc: "Cosa vuol dire lavorare in Cloud? Esempi con Atlas, Databricks e Spark", lessons: ["Lezione 1: Cloud, Iaas, Paas e Saas","Lezione 2: Installazione di MongoDB in cloud","Lezione 3: Interazione con il database in cloud","Lezione 4: Introduzione a Databricks","Lezione 5: Acquisizione di file e query SQL su Databricks","Lezione 6: Spark e Pyspark","Lezione 7: Group by e Join con Spark"] },
      { name: "Azure fundamentals AZ-900", desc: "Lezioni di preparazione alla certificazione Azure fundamentals AZ-900", lessons: ["Lezione 1: Approfondimenti sul cloud computing","Lezione 2: Vantaggi dell'uso dei servizi cloud","Lezione 3: Tipi di servizi cloud","Lezione 4: Componenti principali dell'architettura","Lezione 5: Servizi di calcolo","Lezione 6: Servizi di rete","Lezione 7: Servizi di archiviazione","Lezione 8: Identità, accesso e sicurezza","Lezione 9: Costi","Lezione 10: Governance e conformità","Lezione 11: Gestione delle risorse","Lezione 12: Monitoraggio"] },
      { name: "Azure Database e Azure Data Factory", desc: "Studiamo alcuni servizi del Cloud di Azure specifici per la Data Analysis come il database Azure SQL e il software di ETL Azure Data Factory", lessons: ["Lezione 1: Installazione Database su Azure","Lezione 2: Connessione a un DB Azure SQL","Lezione 3: NON LANCIARE CREATE DATABASE","Lezione 4: Diversa gestione dei Lock","Lezione 5: Considerazioni sulle Performance","Lezione 6: Panoramica degli strumenti di ETL","Lezione 7: Configurazione del servizio Azure Data Factory","Lezione 8: Prima procedura di ETL","Lezione 9: Upsert dei dati senza codice con ADF","Lezione 10: La nostra prima pipeline con Azure Data Factory"] }
    ]
  },
  {
    macro: "CERTIFICAZIONI",
    iconKey: "certs",
    color: "#14b8a6",
    collections: [
      { name: "Certificazione SQL Oracle", desc: "Preparazione completa alla certificazione SQL di Oracle", lessons: ["Lezione 1: introduzione alla certificazione","Lezione 2: funzioni numeriche","Lezione 3: funzioni per le stringhe","Lezione 4: tipo DATE","Lezione 5: tipo INTERVAL","Lezione 6: funzioni su Date","Lezione 7: oggetti particolari di Oracle - parte 1","Lezione 8: oggetti particolari di Oracle - parte 2","Lezione 9: particolarità SQL Plus e SQL Developer","Lezione 10: sintassi particolari - parte 1","Lezione 11: sintassi particolari - parte 2","Lezione 12: Join e Viste","Lezione 13: Subquery","Lezione 14: Particolarità operatori SQL","Lezione 15: vincoli check, transazioni e altro","Lezione 16: istruzioni DCL e Data Dictionary"] },
      { name: "Certificazione Python PCEP", desc: "Prepariamoci alla certificazione del Python Institute PCEP, tramite 300 domande & risposte commentate e una serie di videolezioni di approfondimento.", lessons: ["Lezione 1: Approfondimento su operatori matematici","Lezione 2: Approfondimento su conversioni in base 10","Lezione 3: Approfondimento su operatori vari e valori falsy","Lezione 4: Approfondimento su identità, None, swap e nomi di variabili","Lezione 5: Approfondimento su immutabilità e altri temi","Lezione 6: Approfondimento su operatori and e or","300 domande e risposte per prepararsi alla certificazione PCEP!"] },
      { name: "Certificazione Power BI PL-300", desc: "Scarica le oltre 280 domande con soluzioni e preparati con lezioni specifiche per la certificazione PL-300 Microsoft Power BI Data Analyst", lessons: ["Lezione 1: Approfondimento su import VS direct query","Lezione 2: Approfondimento su gateway e parametri di Power Query","Lezione 3: Approfondimento su query folding","Lezione 4: Approfondimento su Dax e visualizzazioni date","Lezione 5: Acquisizione dati da folder e profiling su Power Query","Lezione 6: Import dal web, left anti join e gestione dei null","Lezione 7: Incremental refresh, SharePoint e Privacy Level","Lezione 8: Varie su Power Query e interazione con Vertipaq","Lezione 9: Varie su DAX e Row level security","Lezione 10: Varie su Power BI Service","280 domande e risposte per prepararsi alla certificazione PL-300!"] }
    ]
  },
  {
    macro: "APPLICAZIONI E APPROFONDIMENTI",
    iconKey: "apps",
    color: "#8b5cf6",
    collections: [
      { name: "Preparazione ai colloqui", desc: "Una raccolta di materiale utile per prepararsi ai colloqui nel mondo della Data Analysis", lessons: ["Lezione 1: Raccontami una tua difficoltà","Lezione 2: Il cliente è arrabbiato","Lezione 3: Elenco domande tecniche e query SQL","Lezione 4: La Statistica","Lezione 5: L'importanza del chiedere","Lezione 6: Come utilizzi l'AI?","Lezione 7: Power BI e Star Schema","Lezione 8: Creazione portfolio progetti","Lezione 9: Riflessioni su licenze e citazioni","Lezione 10: Dispense per ripassare","Lezione 11: Quiz a crocette","Lezione 12: Project Work ed esercitazioni guidate"] },
      { name: "MongoDB", desc: "Il più diffuso database non relazionale: salvataggio in BSON e tecniche di interrogazione", lessons: ["Lezione 1: Installazione e creazione Database","Lezione 2: Documenti JSON","Lezione 3: Collezione JSON","Lezione 4: Eseguiamo i primi filtri","Lezione 5: Scelta delle chiavi e altri esempi","Lezione 6: Combinare più condizioni con OR e AND","Lezione 7: Analisi dei tipi e impatto sui risultati","Lezione 8: Gestione dei null e filtri su array","Lezione 9: Aggregare i dati - parte 1","Lezione 10: Aggregare i dati - parte 2","Lezione 11: Filtri pre e post raggruppamento","Lezione 12: Raggruppamenti su chiavi di tipo array","Lezione 13: Combinare dati di più collection","Lezione 14: Creare database e collezioni","Lezione 15: Aggiornare il database","Lezione 16: Modificare chiavi di tipo array","Lezione 17: Progettazione di un database non relazionale","Lezione 18: Aggiornare array di sotto-documenti","Lezione 19: Funzioni $concat, $ifNull e $cond","Lezione 20: Aggregazioni con $push e $addToSet","Lezione 21: Creiamo una vista","Lezione 22: Regole di validazione","Lezione 23: Introduzione agli indici","Lezione 24: Impatto di un indice sulla find()","Lezione 25: Funzionalità di Compass – parte 1","Lezione 26: Funzionalità di Compass – parte 2","Lezione 27: Confronto tra DB relazionali e documentali","Lezione 28: Dati geospaziali"] },
      { name: "Data Management", desc: "Le basi più importanti di gestione dei dati all'interno di un'azienda", lessons: ["Lezione 1: Cos'è il Data Management?","Lezione 2: Trasformare i dati in informazioni","Lezione 3: Data Modeling, Architecture e Storage","Lezione 4: Data Security e Integration","Lezione 5: Master Data e Data Quality","Lezione 6: Metadata e Document Management","Lezione 7: DataWarehouse, BI e Data Governance"] },
      { name: "Microsoft Access", desc: "Creare un'interfaccia per inserimento, modifica e consultazione dei dati", lessons: ["Lezione 1: La nostra prima Maschera","Lezione 2: Creiamo un Home Page","Lezione 3: Creiamo una maschera di sola lettura","Lezione 4: Aggiungiamo grafici e particolari layout","Lezione 5: Utilizziamo le sottomaschere","Lezione 6: Aggiungere campi e usare i controlli","Lezione 7: Salvataggio delle modifiche tramite VBA","Lezione 8: Creiamo un report","Lezione 9: Report con raggruppamenti","Lezione 10: Maschere parametriche"] },
      { name: "Digital Marketing", desc: "Come interagire tramite Python e il cloud con la Google Search Console", lessons: ["Lezione 1: Introduzione alla Google Search Console","Lezione 2: Configurazione delle credenziali API","Lezione 3: Chiamata API tramite Python","Lezione 4: Acquisizione dei click per data","Lezione 5: Chiamata API con due dimensioni","Lezione 6: Chiamata API con oltre 25000 righe"] },
      { name: "Football Analysis", desc: "Esempi pratici con Excel e Python su dataset legati al calcio", lessons: ["Lezione 1: Import e pulizia dei dati","Lezione 2: Creazione di nuove colonne","Lezione 3: Analisi con tabelle pivot","Lezione 4: Analisi su campionati e ruoli con Excel","Lezione 5: Analisi preliminari con Python","Lezione 6: Gestione dei ruoli con Python","Lezione 7: Primi risultati sui dati","Lezione 8: Analisi su campionati e ruoli con Python"] },
      { name: "Analisi delle serie storiche", desc: "Predizioni sulle date future analizzando l'andamento di una serie storica", lessons: ["Lezione 1: Introduzione alle serie storiche","Lezione 2: Funzionalità foglio previsione di Excel","Lezione 3: Forecast di più prodotti","Lezione 4: Modello matematico – parte 1","Lezione 5: Modello matematico – parte 2","Lezione 6: Import dei dati e controlli con Python","Lezione 7: Medie mobili e stagionalità con Python","Lezione 8: Regressione e previsioni finali con Python"] },
      { name: "Versionamento del codice con Git", desc: "Impariamo a versionare il nostro codice in modo professionale", lessons: ["Lezione 1: Installazione di Git","Lezione 2: Inizializziamo un repository","Lezione 3: I tre livelli di versionamento","Lezione 4: Eseguiamo il nostro primo commit","Lezione 5: Esperimenti sul versionamento","Lezione 6: Esplorare le differenze con Git diff","Lezione 7: Git restore –staged","Lezione 8: Git restore","Lezione 9: Analizziamo una situazione più complessa"] },
      { name: "Dashboard con Tableau", desc: "Impara a utilizzare Tableau per Dashboard efficaci e dall'alto potere visivo", lessons: ["Lezione 1: Installazione Tableau Public Edition","Lezione 2: Creazione di un account su Tableau Public","Lezione 3: Import e arricchimento dei dati","Lezione 4: Grafici per combinare dimensioni e misure","Lezione 5: Grafici su più dimensioni","Lezione 6: Creiamo la nostra prima Dashboard","Lezione 7: Interazione con la Dashboard","Lezione 8: Funzioni IFNULL e IF","Lezione 9: Applicare filtri sull'origine dati","Lezione 10: Analisi dei dati e grafico a albero","Lezione 11: Rappresentazioni tabellari e paginazione","Lezione 12: Rappresentazione di più misure","Lezione 13: Formule per gestire stringhe di testo","Lezione 14: Import dei dati da file di testo","Lezione 15: Import di file JSON","Lezione 16: Import di file Access e Dashboard","Lezione 17: Creare relazioni tra tabelle"] }
    ]
  }
];

// Data Visualization section (small, fits under BI or standalone)
// Already included above in BI as last item would be Tableau + Data Viz

const TOTAL_LESSONS = 700;
const TOTAL_COLLECTIONS = 50;
const TOTAL_MACROS = 7;

function AnimatedCounter({ target, duration = 1500, suffix = "" }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const animate = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setCount(Math.floor(eased * target));
            if (progress < 1) requestAnimationFrame(animate);
          };
          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target, duration]);

  return <span ref={ref}>{count}{suffix}</span>;
}

function CollectionCard({ collection, color, index }) {
  const [isOpen, setIsOpen] = useState(false);
  const lessonCount = collection.lessons.length;

  return (
    <div
      style={{
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: 14,
        padding: "20px 24px",
        cursor: "pointer",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        animationDelay: `${index * 40}ms`,
        position: "relative",
        overflow: "hidden",
      }}
      onClick={() => lessonCount > 0 && setIsOpen(!isOpen)}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.06)";
        e.currentTarget.style.borderColor = color + "44";
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = `0 8px 32px ${color}15`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.03)";
        e.currentTarget.style.borderColor = "rgba(255,255,255,0.06)";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div style={{ position: "absolute", top: 0, left: 0, width: 3, height: "100%", background: color, borderRadius: "3px 0 0 3px" }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 600, color: "#e2e8f0", lineHeight: 1.4 }}>
            {collection.name}
          </div>
          {collection.desc && (
            <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#cbd5e1", marginTop: 6, lineHeight: 1.5 }}>
              {collection.desc}
            </div>
          )}
        </div>
        {lessonCount > 0 && (
          <div style={{
            background: color + "18",
            color: color,
            fontSize: 12,
            fontWeight: 700,
            padding: "4px 10px",
            borderRadius: 20,
            fontFamily: "'JetBrains Mono', monospace",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}>
            {lessonCount}
          </div>
        )}
      </div>
      {isOpen && lessonCount > 0 && (
        <div style={{
          marginTop: 16,
          paddingTop: 16,
          borderTop: "1px solid rgba(255,255,255,0.06)",
        }}>
          {collection.lessons.map((lesson, i) => (
            <div
              key={i}
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 13,
                color: "#cbd5e1",
                padding: "6px 0 6px 12px",
                borderLeft: `2px solid ${color}33`,
                marginBottom: 4,
                transition: "all 0.2s",
                lineHeight: 1.4,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#f1f5f9";
                e.currentTarget.style.borderLeftColor = color;
                e.currentTarget.style.paddingLeft = "16px";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#cbd5e1";
                e.currentTarget.style.borderLeftColor = color + "33";
                e.currentTarget.style.paddingLeft = "12px";
              }}
            >
              {lesson}
            </div>
          ))}
        </div>
      )}
      {lessonCount > 0 && (
        <div style={{ marginTop: 10, textAlign: "right" }}>
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: "#8b9ab8", letterSpacing: 0.5 }}>
            {isOpen ? "▲ chiudi" : "▼ mostra lezioni"}
          </span>
        </div>
      )}
    </div>
  );
}

function MobileCollectionCard({ collection, color }) {
  const [isOpen, setIsOpen] = useState(false);
  const lessonCount = collection.lessons.length;

  return (
    <div
      style={{
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: 10,
        padding: "12px 16px",
        position: "relative",
        overflow: "hidden",
      }}
      onClick={(e) => { e.stopPropagation(); if (lessonCount > 0) setIsOpen(!isOpen); }}
    >
      <div style={{ position: "absolute", top: 0, left: 0, width: 3, height: "100%", background: color, borderRadius: "3px 0 0 3px" }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 600, color: "#e2e8f0", lineHeight: 1.4 }}>
            {collection.name}
          </div>
          {collection.desc && (
            <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: "#b0bdd0", marginTop: 4, lineHeight: 1.4 }}>
              {collection.desc}
            </div>
          )}
        </div>
        {lessonCount > 0 && (
          <div style={{
            background: color + "18",
            color: color,
            fontSize: 11,
            fontWeight: 700,
            padding: "3px 8px",
            borderRadius: 20,
            fontFamily: "'JetBrains Mono', monospace",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}>
            {lessonCount}
          </div>
        )}
      </div>
      {isOpen && lessonCount > 0 && (
        <div style={{
          marginTop: 10,
          paddingTop: 10,
          borderTop: "1px solid rgba(255,255,255,0.06)",
        }}>
          {collection.lessons.map((lesson, i) => (
            <div
              key={i}
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 12,
                color: "#cbd5e1",
                padding: "5px 0 5px 10px",
                borderLeft: `2px solid ${color}33`,
                marginBottom: 3,
                lineHeight: 1.4,
              }}
            >
              {lesson}
            </div>
          ))}
        </div>
      )}
      {lessonCount > 0 && (
        <div style={{ marginTop: 8, textAlign: "right" }}>
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: "#8b9ab8", letterSpacing: 0.5 }}>
            {isOpen ? "▲ chiudi" : "▼ mostra lezioni"}
          </span>
        </div>
      )}
    </div>
  );
}

const MacroSection = forwardRef(function MacroSection({ section, isActive, onClick }, ref) {
  const totalLessons = section.collections.reduce((sum, c) => sum + c.lessons.length, 0);

  return (
    <div ref={ref} className={`macro-section-wrapper${isActive ? " macro-section-active" : ""}`}>
      <div
        onClick={onClick}
        style={{
          padding: "16px 20px",
          borderRadius: 12,
          cursor: "pointer",
          background: isActive ? section.color + "15" : "transparent",
          border: isActive ? `1px solid ${section.color}44` : "1px solid transparent",
          transition: "all 0.3s ease",
          display: "flex",
          alignItems: "center",
          gap: 14,
        }}
        onMouseEnter={(e) => {
          if (!isActive) {
            e.currentTarget.style.background = "rgba(255,255,255,0.03)";
          }
        }}
        onMouseLeave={(e) => {
          if (!isActive) {
            e.currentTarget.style.background = "transparent";
          }
        }}
      >
        <span style={{ fontSize: 28, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{SectionIcons[section.iconKey]({ size: 32, color: section.color })}</span>
        <div style={{ flex: 1 }}>
          <div style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 14,
            fontWeight: 700,
            color: isActive ? section.color : "#94a3b8",
            letterSpacing: 0.8,
            textTransform: "uppercase",
            transition: "color 0.3s",
          }}>
            {section.macro}
          </div>
          <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: "#b0bdd0", marginTop: 3 }}>
            {section.collections.length} raccolte · {totalLessons} lezioni
          </div>
        </div>
        <div className="macro-section-plus" style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: isActive ? section.color : "transparent",
          transition: "all 0.3s",
          boxShadow: isActive ? `0 0 12px ${section.color}88` : "none",
          flexShrink: 0,
        }} />
      </div>
      {/* Mobile inline collections */}
      {isActive && (
        <div className="mobile-inline-collections" style={{ display: "none" }}>
          <div style={{ padding: "8px 16px 16px", display: "flex", flexDirection: "column", gap: 6 }}>
            {section.collections.map((collection, i) => (
              <MobileCollectionCard key={i} collection={collection} color={section.color} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
});

function CookieBanner({ onAccept, onDecline }) {
  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: "rgba(15, 23, 42, 0.97)",
      backdropFilter: "blur(12px)",
      borderTop: "1px solid rgba(255,255,255,0.08)",
      padding: "16px 24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 16,
      flexWrap: "wrap",
      fontFamily: "'DM Sans', sans-serif",
      animation: "fadeInUp 0.4s ease both",
    }}>
      <span style={{ fontSize: 14, color: "#b0bdd0", maxWidth: 600 }}>
        Gestisci consenso — Questo sito non utilizza cookie di profilazione. L'unico servizio esterno è Google Fonts, per migliorare la leggibilità. Acconsenti al caricamento? <a href="https://www.yimp.it/cookie-policy/" target="_blank" rel="noopener noreferrer" style={{ color: "#6ec1e4", textDecoration: "underline" }}>Cookie Policy</a>
      </span>
      <div style={{ display: "flex", gap: 8 }}>
        <button
          onClick={onAccept}
          style={{
            padding: "8px 20px",
            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
            color: "#fff",
            fontSize: 13,
            fontWeight: 600,
            borderRadius: 50,
            border: "none",
            cursor: "pointer",
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
          onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
        >
          Accetta
        </button>
        <button
          onClick={onDecline}
          style={{
            padding: "8px 20px",
            background: "rgba(255,255,255,0.08)",
            color: "#b0bdd0",
            fontSize: 13,
            fontWeight: 600,
            borderRadius: 50,
            border: "1px solid rgba(255,255,255,0.1)",
            cursor: "pointer",
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
          onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
        >
          Rifiuta
        </button>
      </div>
    </div>
  );
}

function Dashboard() {
  const [activeSection, setActiveSection] = useState(() => {
    return window.innerWidth <= 768 ? null : 0;
  });
  const [showAllSections, setShowAllSections] = useState(false);
  const contentRef = useRef(null);
  const sidebarRef = useRef(null);

  const [reviewIndex, setReviewIndex] = useState(0);
  const [openFaqs, setOpenFaqs] = useState(new Set());

  // Preload all review images so navigation is instant
  const preloadedImages = useRef([]);
  useEffect(() => {
    const imgs = [];
    for (let i = 1; i <= REVIEWS_COUNT; i++) {
      const d = new Image();
      d.src = `${process.env.PUBLIC_URL}/Recensione${i}_desktop.jpg`;
      const m = new Image();
      m.src = `${process.env.PUBLIC_URL}/Recensione${i}_mobile.jpg`;
      imgs.push(d, m);
    }
    preloadedImages.current = imgs;
  }, []);

  // Swipe support for review images on mobile
  const touchStartX = useRef(null);
  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      setReviewIndex((prev) => diff > 0
        ? (prev + 1) % REVIEWS_COUNT
        : (prev - 1 + REVIEWS_COUNT) % REVIEWS_COUNT
      );
    }
    touchStartX.current = null;
  };

  const [cookieConsent, setCookieConsent] = useState(() => {
    try { return localStorage.getItem("cookie_consent"); } catch { return null; }
  });

  const handleCookieAccept = () => {
    setCookieConsent("accepted");
    try { localStorage.setItem("cookie_consent", "accepted"); } catch {}
  };

  const handleCookieDecline = () => {
    setCookieConsent("declined");
    try { localStorage.setItem("cookie_consent", "declined"); } catch {}
  };

  const sectionRefs = useRef([]);

  const handleSectionClick = (index) => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      const isOpening = activeSection !== index;
      setActiveSection(activeSection === index ? null : index);
      if (isOpening) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const el = sectionRefs.current[index];
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          });
        });
      }
    } else {
      setActiveSection(index);
      setTimeout(() => {
        if (contentRef.current) {
          contentRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 50);
    }
  };

  const currentSection = activeSection !== null ? SECTIONS_DATA[activeSection] : SECTIONS_DATA[0];

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0b1121",
      color: "#e2e8f0",
      position: "relative",
      overflowX: "hidden",
    }}>
      {cookieConsent === "accepted" && (
        <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;700&display=swap" rel="stylesheet" />
      )}

      {/* AI Neural Background */}
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none", zIndex: 0, overflow: "hidden" }}>
        {/* Ambient glow */}
        <div style={{
          position: "absolute", inset: 0,
          background: `
            radial-gradient(ellipse 900px 700px at 15% 5%, rgba(99,102,241,0.08) 0%, transparent 55%),
            radial-gradient(ellipse 700px 500px at 85% 85%, rgba(244,63,94,0.06) 0%, transparent 55%),
            radial-gradient(ellipse 500px 500px at 50% 40%, rgba(14,165,233,0.05) 0%, transparent 55%),
            radial-gradient(ellipse 400px 300px at 70% 20%, rgba(245,158,11,0.04) 0%, transparent 50%)
          `,
        }} />
        {/* Floating nodes */}
        <svg className="neural-bg" width="100%" height="100%" style={{ position: "absolute", inset: 0 }}>
          <defs>
            <radialGradient id="glow1"><stop offset="0%" stopColor="#6366f1" stopOpacity="0.6"/><stop offset="100%" stopColor="#6366f1" stopOpacity="0"/></radialGradient>
            <radialGradient id="glow2"><stop offset="0%" stopColor="#0ea5e9" stopOpacity="0.5"/><stop offset="100%" stopColor="#0ea5e9" stopOpacity="0"/></radialGradient>
            <radialGradient id="glow3"><stop offset="0%" stopColor="#f43f5e" stopOpacity="0.4"/><stop offset="100%" stopColor="#f43f5e" stopOpacity="0"/></radialGradient>
            <radialGradient id="glow4"><stop offset="0%" stopColor="#f59e0b" stopOpacity="0.5"/><stop offset="100%" stopColor="#f59e0b" stopOpacity="0"/></radialGradient>
          </defs>
          {/* Connection lines */}
          <line x1="10%" y1="15%" x2="30%" y2="35%" stroke="#6366f1" strokeWidth="0.5" opacity="0.15"><animate attributeName="opacity" values="0.05;0.15;0.05" dur="4s" repeatCount="indefinite"/></line>
          <line x1="30%" y1="35%" x2="55%" y2="20%" stroke="#0ea5e9" strokeWidth="0.5" opacity="0.12"><animate attributeName="opacity" values="0.04;0.12;0.04" dur="5s" repeatCount="indefinite"/></line>
          <line x1="55%" y1="20%" x2="80%" y2="40%" stroke="#f43f5e" strokeWidth="0.5" opacity="0.1"><animate attributeName="opacity" values="0.03;0.1;0.03" dur="6s" repeatCount="indefinite"/></line>
          <line x1="80%" y1="40%" x2="65%" y2="70%" stroke="#f59e0b" strokeWidth="0.5" opacity="0.12"><animate attributeName="opacity" values="0.04;0.12;0.04" dur="4.5s" repeatCount="indefinite"/></line>
          <line x1="65%" y1="70%" x2="35%" y2="80%" stroke="#10b981" strokeWidth="0.5" opacity="0.1"><animate attributeName="opacity" values="0.03;0.1;0.03" dur="5.5s" repeatCount="indefinite"/></line>
          <line x1="35%" y1="80%" x2="10%" y2="60%" stroke="#8b5cf6" strokeWidth="0.5" opacity="0.12"><animate attributeName="opacity" values="0.05;0.12;0.05" dur="4s" repeatCount="indefinite"/></line>
          {/* Nodes */}
          <circle cx="10%" cy="15%" r="6" fill="url(#glow1)"><animate attributeName="cy" values="15%;17%;15%" dur="6s" repeatCount="indefinite"/></circle>
          <circle cx="10%" cy="15%" r="2" fill="#6366f1" opacity="0.7"><animate attributeName="cy" values="15%;17%;15%" dur="6s" repeatCount="indefinite"/></circle>
          <circle cx="30%" cy="35%" r="8" fill="url(#glow2)"><animate attributeName="cy" values="35%;32%;35%" dur="5s" repeatCount="indefinite"/></circle>
          <circle cx="30%" cy="35%" r="2.5" fill="#0ea5e9" opacity="0.6"><animate attributeName="cy" values="35%;32%;35%" dur="5s" repeatCount="indefinite"/></circle>
          <circle cx="55%" cy="20%" r="7" fill="url(#glow3)"><animate attributeName="cx" values="55%;57%;55%" dur="7s" repeatCount="indefinite"/></circle>
          <circle cx="55%" cy="20%" r="2" fill="#f43f5e" opacity="0.6"><animate attributeName="cx" values="55%;57%;55%" dur="7s" repeatCount="indefinite"/></circle>
          <circle cx="80%" cy="40%" r="6" fill="url(#glow4)"><animate attributeName="cy" values="40%;43%;40%" dur="5.5s" repeatCount="indefinite"/></circle>
          <circle cx="80%" cy="40%" r="2" fill="#f59e0b" opacity="0.7"><animate attributeName="cy" values="40%;43%;40%" dur="5.5s" repeatCount="indefinite"/></circle>
          <circle cx="65%" cy="70%" r="7" fill="url(#glow1)"><animate attributeName="cx" values="65%;63%;65%" dur="6.5s" repeatCount="indefinite"/></circle>
          <circle cx="65%" cy="70%" r="2" fill="#6366f1" opacity="0.5"><animate attributeName="cx" values="65%;63%;65%" dur="6.5s" repeatCount="indefinite"/></circle>
          <circle cx="35%" cy="80%" r="6" fill="url(#glow2)"><animate attributeName="cy" values="80%;78%;80%" dur="4.5s" repeatCount="indefinite"/></circle>
          <circle cx="35%" cy="80%" r="2" fill="#0ea5e9" opacity="0.5"><animate attributeName="cy" values="80%;78%;80%" dur="4.5s" repeatCount="indefinite"/></circle>
          <circle cx="10%" cy="60%" r="5" fill="url(#glow3)"><animate attributeName="cy" values="60%;62%;60%" dur="5s" repeatCount="indefinite"/></circle>
          <circle cx="10%" cy="60%" r="1.5" fill="#8b5cf6" opacity="0.6"><animate attributeName="cy" values="60%;62%;60%" dur="5s" repeatCount="indefinite"/></circle>
          {/* Small accent nodes */}
          <circle cx="45%" cy="50%" r="1" fill="#f59e0b" opacity="0.4"><animate attributeName="opacity" values="0.2;0.5;0.2" dur="3s" repeatCount="indefinite"/></circle>
          <circle cx="20%" cy="45%" r="1" fill="#10b981" opacity="0.3"><animate attributeName="opacity" values="0.1;0.4;0.1" dur="4s" repeatCount="indefinite"/></circle>
          <circle cx="75%" cy="25%" r="1" fill="#6366f1" opacity="0.3"><animate attributeName="opacity" values="0.15;0.4;0.15" dur="3.5s" repeatCount="indefinite"/></circle>
          <circle cx="90%" cy="65%" r="1" fill="#f43f5e" opacity="0.3"><animate attributeName="opacity" values="0.1;0.35;0.1" dur="4.5s" repeatCount="indefinite"/></circle>
        </svg>
        {/* Subtle grid */}
        <div style={{
          position: "absolute", inset: 0,
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)
          `,
          backgroundSize: "60px 60px",
        }} />
      </div>

      <div style={{ position: "relative", zIndex: 1 }}>
        {/* Hero Header */}
        <div className="hero-header" style={{
          padding: "72px 32px 56px",
          textAlign: "center",
          borderBottom: "1px solid rgba(255,255,255,0.04)",
        }}>
          {/* Foto profilo */}
          <div style={{ animation: "fadeInDown 0.8s ease both", marginBottom: 24 }}>
            <img
              src={process.env.PUBLIC_URL + "/nicola-iantomasi-compresso.jpg"}
              alt="Nicola Iantomasi"
              style={{
                width: "clamp(110px, 18vw, 160px)",
                height: "clamp(110px, 18vw, 160px)",
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid rgba(245,158,11,0.5)",
                boxShadow: "0 0 40px rgba(245,158,11,0.15), 0 4px 20px rgba(0,0,0,0.4)",
              }}
            />
          </div>
          <div className="hero-subtitle" style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "clamp(9px, 2.2vw, 13px)",
            fontWeight: 600,
            letterSpacing: "clamp(1px, 0.5vw, 4px)",
            color: "#b0bdd0",
            textTransform: "uppercase",
            marginBottom: 16,
            animation: "fadeInDown 0.8s ease both",
          }}>
            La Scuola dei Dati<span className="hero-subtitle-dash"> - </span><br className="mobile-only-br-subtitle" />Il percorso completo
          </div>
          <h1 className="hero-title" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "clamp(32px, 5vw, 52px)",
            fontWeight: 700,
            margin: 0,
            background: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 40%, #d97706 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: -1,
            animation: "fadeInUp 0.8s ease 0.2s both",
            filter: "drop-shadow(0 0 30px rgba(245,158,11,0.3))",
          }}>
            Costruisci oggi<br className="mobile-only-br" /> la tua carriera in<br className="desktop-only-br" /><br className="mobile-only-br" /> Data Analysis e<br className="mobile-only-br" /> Intelligenza Artificiale
          </h1>
          <p className="hero-description" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 16,
            color: "#b0bdd0",
            marginTop: 12,
            maxWidth: 750,
            marginLeft: "auto",
            marginRight: "auto",
            lineHeight: 1.6,
            animation: "fadeInUp 0.8s ease 0.4s both",
          }}>
            All'interno della Scuola dei Dati trovi tutti i temi di cui hai bisogno spiegati in un unico percorso completo, organico e strutturato, pensato per accompagnarti passo dopo passo, anche se parti da zero.
          </p>

          {/* CTA Button */}
          <div style={{ animation: "fadeInUp 0.8s ease 0.6s both" }}>
          <a
            className="cta-btn"
            href="https://www.patreon.com/checkout/nicolaiantomasi?rid=8101904"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              marginTop: 28,
              padding: "14px 36px",
              background: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
              color: "#fff",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 15,
              fontWeight: 700,
              borderRadius: 50,
              textDecoration: "none",
              letterSpacing: 0.5,
              boxShadow: "0 4px 24px rgba(244,63,94,0.35), 0 1px 3px rgba(0,0,0,0.3)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "none",
              cursor: "pointer",
              position: "relative",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
              e.currentTarget.style.boxShadow = "0 8px 40px rgba(244,63,94,0.55), 0 2px 6px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 24px rgba(244,63,94,0.35), 0 1px 3px rgba(0,0,0,0.3)";
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M14.82 2.41c3.96 0 7.18 3.24 7.18 7.21 0 3.96-3.22 7.18-7.18 7.18H9.04V2.41h5.78zm-3.78 2v10.39h3.78c2.85 0 5.18-2.32 5.18-5.18 0-2.87-2.33-5.21-5.18-5.21h-3.78zM2 2.41h5.04v14.39H2V2.41z"/>
            </svg>
            Iscriviti su Patreon
          </a>
          <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#b0bdd0", marginTop: 10 }}>Accedi a soli 14,99€ al mese e disdici quando vuoi.</div>
          </div>
        </div>

        {/* Stats bar */}
        <div className="stats-bar" style={{
          display: "flex",
          justifyContent: "center",
          gap: "clamp(24px, 5vw, 64px)",
          padding: "40px 20px",
          borderBottom: "1px solid rgba(255,255,255,0.04)",
          flexWrap: "wrap",
        }}>
          {[
            { value: 120, label: "Ore di lezione", suffix: "+" },
            { value: TOTAL_COLLECTIONS, label: "Corsi", suffix: "+" },
            { value: TOTAL_LESSONS, label: "Video lezioni", suffix: "+" },
          ].map((stat, i) => (
            <div key={i} style={{ textAlign: "center" }}>
              <div style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "clamp(28px, 4vw, 42px)",
                fontWeight: 700,
                color: "#8b5cf6",
                textShadow: "0 0 40px #8b5cf630",
              }}>
                <AnimatedCounter target={stat.value} suffix={stat.suffix} />
              </div>
              <div style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 12,
                color: "#b0bdd0",
                letterSpacing: 1.5,
                textTransform: "uppercase",
                marginTop: 4,
              }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Main Content */}
          <div style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "32px 20px 80px",
            display: "grid",
            gridTemplateColumns: "clamp(240px, 28%, 320px) 1fr",
            gap: 32,
          }}>
            {/* Sidebar */}
            <div className="sidebar-nav sidebar-scroll" ref={sidebarRef} style={{
              position: "sticky",
              top: 20,
              alignSelf: "start",
              maxHeight: "calc(100vh - 40px)",
              overflowY: "scroll",
            }}>
              <div className="aree-label" style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 10,
                letterSpacing: 3,
                color: "#b0bdd0",
                textTransform: "uppercase",
                marginBottom: 4,
                paddingLeft: 20,
              }}>
                Aree tematiche
              </div>
              <div className="aree-hint" style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 12,
                color: "#f59e0b",
                marginBottom: 16,
                paddingLeft: 20,
              }}>
                Clicca su un'area per esplorare le raccolte
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                {SECTIONS_DATA.map((section, i) => (
                  <MacroSection
                    key={i}
                    ref={(el) => { sectionRefs.current[i] = el; }}
                    section={section}
                    isActive={activeSection === i}
                    onClick={() => handleSectionClick(i)}
                  />
                ))}
              </div>
            </div>

            {/* Content */}
            <div ref={contentRef} className="desktop-content-area">
              <div className="content-section-header" style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                marginBottom: 8,
              }}>
                <span style={{ display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{SectionIcons[currentSection.iconKey]({ size: 44, color: currentSection.color })}</span>
                <div>
                  <h2 style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: "clamp(22px, 3vw, 28px)",
                    fontWeight: 700,
                    margin: 0,
                    color: currentSection.color,
                    letterSpacing: -0.5,
                  }}>
                    {currentSection.macro}
                  </h2>
                  <div style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: 12,
                    color: "#8b9ab8",
                    marginTop: 4,
                  }}>
                    {currentSection.collections.length} raccolte · {currentSection.collections.reduce((s, c) => s + c.lessons.length, 0)} lezioni
                  </div>
                </div>
              </div>

              {/* Progress bar visual */}
              <div style={{
                height: 3,
                background: "rgba(255,255,255,0.04)",
                borderRadius: 3,
                marginBottom: 28,
                overflow: "hidden",
              }}>
                <div style={{
                  height: "100%",
                  width: `${(currentSection.collections.reduce((s, c) => s + c.lessons.length, 0) / TOTAL_LESSONS) * 100}%`,
                  background: `linear-gradient(90deg, ${currentSection.color}, ${currentSection.color}88)`,
                  borderRadius: 3,
                  transition: "width 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                }} />
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {currentSection.collections.map((collection, i) => (
                  <CollectionCard
                    key={`${activeSection}-${i}`}
                    collection={collection}
                    color={currentSection.color}
                    index={i}
                  />
                ))}
              </div>
            </div>
          </div>

        {/* Mobile-only: back to top button */}
          <div className="mobile-only-btn mobile-back-wrapper" style={{
            textAlign: "center",
            padding: "0 20px",
          }}>
            <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", margin: "0 20px" }} />
            <div style={{ padding: "20px 0" }}>
              <button
                onClick={() => {
                  if (sidebarRef.current) {
                    sidebarRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                  }
                }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "14px 32px",
                  background: "rgba(245,158,11,0.12)",
                  color: "#f59e0b",
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 15,
                  fontWeight: 700,
                  borderRadius: 50,
                  border: "2px solid #f59e0b",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  boxShadow: "0 0 12px rgba(245,158,11,0.2)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(245,158,11,0.25)";
                  e.currentTarget.style.color = "#fbbf24";
                  e.currentTarget.style.boxShadow = "0 0 20px rgba(245,158,11,0.35)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(245,158,11,0.12)";
                  e.currentTarget.style.color = "#f59e0b";
                  e.currentTarget.style.boxShadow = "0 0 12px rgba(245,158,11,0.2)";
                }}
              >
                <span style={{ fontSize: 22, fontWeight: 900, lineHeight: 1, textShadow: "0 0 6px rgba(245,158,11,0.5)" }}>▲</span> Esplora un'altra area tematica
              </button>
            </div>
            <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", margin: "0 20px" }} />
          </div>

        {/* Footer CTA */}
        <div style={{
          textAlign: "center",
          padding: "48px 20px 56px",
          borderTop: "1px solid rgba(255,255,255,0.04)",
        }}>
          <div style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "clamp(20px, 3vw, 28px)",
            fontWeight: 700,
            color: "#e2e8f0",
            marginBottom: 12,
          }}>
            <div className="footer-cta-photo" style={{ marginBottom: 20 }}>
              <img
                src={process.env.PUBLIC_URL + "/nicola-iantomasi-compresso.jpg"}
                alt="Nicola Iantomasi"
                style={{
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "3px solid rgba(245,158,11,0.5)",
                  boxShadow: "0 0 40px rgba(245,158,11,0.15), 0 4px 20px rgba(0,0,0,0.4)",
                }}
              />
            </div>
            Inizia il tuo percorso
          </div>
          <div style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 16,
            color: "#b0bdd0",
            marginBottom: 28,
            maxWidth: 680,
            margin: "0 auto 28px",
            lineHeight: 1.6,
          }}>
            Oltre 600 video lezioni strutturate arricchite da materiali didattici, esercitazioni guidate, project work, preparazione alle certificazioni Oracle, Python e Power BI. Per portarti da zero a professionista nel mondo dei dati e dell'Intelligenza Artificiale.
          </div>
          <a
            href="https://www.patreon.com/checkout/nicolaiantomasi?rid=8101904"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              padding: "16px 44px",
              background: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
              color: "#fff",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 16,
              fontWeight: 700,
              borderRadius: 50,
              textDecoration: "none",
              letterSpacing: 0.5,
              boxShadow: "0 4px 24px rgba(244,63,94,0.35)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "none",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
              e.currentTarget.style.boxShadow = "0 8px 40px rgba(244,63,94,0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 24px rgba(244,63,94,0.35)";
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M14.82 2.41c3.96 0 7.18 3.24 7.18 7.21 0 3.96-3.22 7.18-7.18 7.18H9.04V2.41h5.78zm-3.78 2v10.39h3.78c2.85 0 5.18-2.32 5.18-5.18 0-2.87-2.33-5.21-5.18-5.21h-3.78zM2 2.41h5.04v14.39H2V2.41z"/>
            </svg>
            Iscriviti ora su Patreon
          </a>
        </div>

        {/* Come funziona - Video Section */}
        <div style={{
          padding: "56px 20px",
          textAlign: "center",
          borderBottom: "1px solid rgba(255,255,255,0.04)",
        }}>
          <h2 style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "clamp(22px, 4vw, 32px)",
            fontWeight: 700,
            color: "#e2e8f0",
            margin: "0 0 8px",
          }}>
            Come funziona<br className="mobile-only-br" /> La Scuola dei Dati
          </h2>
          <p style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 15,
            color: "#b0bdd0",
            marginBottom: 32,
          }}>
            Scopri come è organizzata la piattaforma
          </p>
          <div style={{
            maxWidth: 720,
            margin: "0 auto",
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 8px 40px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.06)",
          }}>
            <div style={{
              padding: "56.25% 0 0 0",
              position: "relative",
            }}>
              <iframe
                src="https://player.vimeo.com/video/1171154060?badge=0&autopause=0&player_id=0&app_id=58479&dnt=1"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                title="Come funziona la Scuola dei Dati"
              />
            </div>
          </div>
          <a
            className="cta-btn"
            href="https://www.patreon.com/checkout/nicolaiantomasi?rid=8101904"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              marginTop: 48,
              padding: "16px 44px",
              background: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
              color: "#fff",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 16,
              fontWeight: 700,
              borderRadius: 50,
              textDecoration: "none",
              letterSpacing: 0.5,
              boxShadow: "0 4px 24px rgba(244,63,94,0.35), 0 1px 3px rgba(0,0,0,0.3)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "none",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
              e.currentTarget.style.boxShadow = "0 8px 40px rgba(244,63,94,0.55), 0 2px 6px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 24px rgba(244,63,94,0.35), 0 1px 3px rgba(0,0,0,0.3)";
            }}
          >
            Iscriviti su Patreon
          </a>
          <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#b0bdd0", marginTop: 10 }}>Accedi a soli 14,99€ al mese e disdici quando vuoi.</div>
        </div>

        {/* Reviews section */}
        <div style={{
          padding: "32px 20px 48px",
          maxWidth: 900,
          margin: "0 auto",
        }}>
          <h3 style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 22,
            fontWeight: 700,
            color: "#e2e8f0",
            textAlign: "center",
            marginBottom: 32,
          }}>
            Recensioni
          </h3>
          {/* Review image */}
          <div
            onClick={() => setReviewIndex((prev) => (prev + 1) % REVIEWS_COUNT)}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            style={{ cursor: "pointer" }}
          >
            <img
              key={`desktop-${reviewIndex}`}
              className="review-img-desktop"
              src={`${process.env.PUBLIC_URL}/Recensione${reviewIndex + 1}_desktop.jpg`}
              alt={`Recensione ${reviewIndex + 1}`}
              style={{ width: "100%", height: "auto", borderRadius: 12, display: "block" }}
            />
            <img
              key={`mobile-${reviewIndex}`}
              className="review-img-mobile"
              src={`${process.env.PUBLIC_URL}/Recensione${reviewIndex + 1}_mobile.jpg`}
              alt={`Recensione ${reviewIndex + 1}`}
              style={{ width: "100%", height: "auto", borderRadius: 12, display: "none" }}
            />
          </div>
          {/* Navigation arrows */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, marginTop: 20 }}>
            <button
              aria-label="Recensione precedente"
              onClick={() => setReviewIndex((prev) => (prev - 1 + REVIEWS_COUNT) % REVIEWS_COUNT)}
              style={{
                flexShrink: 0,
                width: 44,
                height: 44,
                borderRadius: "50%",
                background: "rgba(245,158,11,0.15)",
                border: "1.5px solid #f59e0b",
                color: "#f59e0b",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(245,158,11,0.3)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(245,158,11,0.15)"; }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
            <button
              aria-label="Recensione successiva"
              onClick={() => setReviewIndex((prev) => (prev + 1) % REVIEWS_COUNT)}
              style={{
                flexShrink: 0,
                width: 44,
                height: 44,
                borderRadius: "50%",
                background: "rgba(245,158,11,0.15)",
                border: "1.5px solid #f59e0b",
                color: "#f59e0b",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(245,158,11,0.3)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(245,158,11,0.15)"; }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>
        </div>

        {/* Final CTA section */}
        <div style={{
          textAlign: "center",
          padding: "48px 20px 56px",
          maxWidth: 900,
          margin: "0 auto",
        }}>
          <p style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 17,
            lineHeight: 1.8,
            color: "#cbd5e1",
            marginBottom: 32,
          }}>
            La Scuola dei Dati è il posto giusto per formarsi come Data Analyst, Data Scientist, AI Engineer, Data Engineer e SQL Developer, o per imparare al meglio ad analizzare i dati nel proprio settore.
          </p>

          <a
            href="https://www.patreon.com/checkout/nicolaiantomasi?rid=8101904"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              padding: "16px 44px",
              background: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
              color: "#fff",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 16,
              fontWeight: 700,
              borderRadius: 50,
              textDecoration: "none",
              letterSpacing: 0.5,
              boxShadow: "0 4px 24px rgba(244,63,94,0.35)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "none",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
              e.currentTarget.style.boxShadow = "0 8px 40px rgba(244,63,94,0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 24px rgba(244,63,94,0.35)";
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M14.82 2.41c3.96 0 7.18 3.24 7.18 7.21 0 3.96-3.22 7.18-7.18 7.18H9.04V2.41h5.78zm-3.78 2v10.39h3.78c2.85 0 5.18-2.32 5.18-5.18 0-2.87-2.33-5.21-5.18-5.21h-3.78zM2 2.41h5.04v14.39H2V2.41z"/>
            </svg>
            Iscriviti su Patreon
          </a>
          <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#b0bdd0", marginTop: 10 }}>Accedi a soli 14,99€ al mese e disdici quando vuoi.</div>
        </div>

        {/* FAQ section */}
        <div style={{
          maxWidth: 900,
          margin: "0 auto",
          padding: "64px 20px 48px",
        }}>
          <h3 style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 22,
            fontWeight: 700,
            color: "#e2e8f0",
            textAlign: "center",
            marginBottom: 32,
          }}>
            Domande frequenti
          </h3>
          {[
            {
              q: "Sono interessato solo alla parte di Excel / Power BI / Python / SQL eccetera. Posso seguire solo quella?",
              a: "Certamente! Tutte le raccolte di lezioni sono catalogate per essere trovate con facilità. La Scuola dei Dati è pensata per fornire un percorso organico nel mondo della Data Analysis e AI, ma se sei interessato ad un argomento specifico, sei libero di seguire solo quello che ti interessa e poi disdire l'abbonamento. Io sono sempre a disposizione per guidarti con chiarezza tra le sole lezioni di tuo interesse.",
            },
            {
              q: "Non ho mai studiato Data Analysis. Posso seguire comunque la Scuola dei Dati?",
              a: "Assolutamente sì! La Scuola dei Dati propone un percorso organico e strutturato pensato per chi parte da zero. Inoltre non sei mai da solo. Puoi sempre contattarmi anche telefonicamente per tenere sotto controllo il tuo piano di studi. Ho oltre 3000 ore di esperienza in corsi del genere. La Scuola dei Dati non è comunque un corso di alfabetizzazione informatica, un minimo di dimestichezza con il PC serve. Se hai quella, poi serve solo tanta volontà!",
            },
            {
              q: "Quando posso disdire dall'abbonamento?",
              a: "Quando vuoi. Con pochi e semplicissimi click. Anche durante il primo mese. E se cambi idea, nessuno ti vieterà di rientrare nuovamente in un secondo momento. Il motto è \"Impara, provi, apprendi fin quando ne hai davvero bisogno\"",
            },
            {
              q: "Se mi dimentico di disdire, posso chiedere un rimborso?",
              a: "Certo! Hai tempo 14 giorni, entro i quali ti basterà scrivermi via chat o al 3207218062 e riceverai il rimborso.",
            },
            {
              q: "Ho un problema con Excel - Python - Power BI - SQL non inerente gli argomenti della piattaforma. Posso chiedere?",
              a: "Certamente! Sarò felice di risponderti. Tieni presente comunque che le tue domande sono fatte in un contesto \"didattico\" e non \"consulenziale\".",
            },
            {
              q: "C'è questo progetto di Data Analysis che vorrei realizzare. Posso proporlo?",
              a: "Certamente, è già successo più volte!",
            },
            {
              q: "La Scuola dei Dati mi prepara a ottenere delle certificazioni?",
              a: "Sì, sono presenti percorsi specifici per le certificazioni Database SQL 1Z0-071 di Oracle, Python PCEP del Python Institute e PL-300 Power BI Data Analyst di Microsoft. Si tratta di certificazioni importanti ottenibili in seguito al superamento dei relativi esami proposti da enti di rilevanza internazionale, spesso anche abbastanza complessi. La Scuola dei Dati contiene del materiale e delle lezioni mirate per prepararsi a questi esami.",
            },
            {
              q: "Quanto dura la Scuola dei Dati?",
              a: "Al momento la Scuola dei Dati contiene più di 100 ore di videolezioni sempre disponibili e in continua espansione. Ogni studente può restare iscritto per tutto il tempo che ritiene necessario, fin quando reputa La Scuola dei Dati un valore aggiunto alla sua formazione e al suo aggiornamento sulla Data Analysis e l'Intelligenza Artificiale. Sei libero di restare abbonato per il tempo che vuoi, di disabbonarti, di abbonarti di nuovo perché hai bisogno di formazione o ti interessa un nuovo argomento. Tutto con pochi e semplicissimi click.",
            },
            {
              q: "Troverò degli esercizi da fare?",
              a: "Le lezioni della Scuola dei Dati sono corredate da tantissimi materiali ed esercizi sotto forma di quiz, esercitazioni guidate, domande & risposte e Project Work!",
            },
            {
              q: "Cos'è Patreon?",
              a: "www.patreon.com è un sito web di fama internazionale, che conta a oggi oltre 6 milioni di iscritti nel mondo. Viene utilizzato da professionisti nell'ambito della tecnologia, didattica, fotografia, musica per avere a disposizione una piattaforma seria e affidabile per divulgare i propri contenuti.",
            },
            {
              q: "Chi è Nicola Iantomasi?",
              a: "Sono un formatore e consulente con oltre 10 anni di esperienza nell'ambito dell'analisi e della gestione dei dati. Ho più di 3000 ore di esperienza in corsi per aziende, centri di formazione e professionisti. Cerco di riportare nelle videolezioni tutti quei metodi didattici che ho affinato durante le ore di didattica dal vivo e pratica sul campo. Ho ottenuto le certificazioni MCSE Data Management e Analytics di Microsoft, Database SQL di Oracle e Professional Scrum Master da Scrum.org. Oltre all'analisi dei dati e l'AI, un'altra mia grande passione è la matematica che ho studiato all'università.",
            },
          ].map((faq, i) => (
            <div key={i} style={{
              marginBottom: 12,
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 12,
              overflow: "hidden",
              background: openFaqs.has(i) ? "rgba(255,255,255,0.04)" : "transparent",
              transition: "background 0.3s",
            }}>
              <button
                aria-expanded={openFaqs.has(i)}
                onClick={() => setOpenFaqs(prev => {
                  const next = new Set(prev);
                  if (next.has(i)) next.delete(i); else next.add(i);
                  return next;
                })}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 16,
                  padding: "18px 20px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  textAlign: "left",
                }}
              >
                <span style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#e2e8f0",
                  lineHeight: 1.5,
                }}>
                  {faq.q}
                </span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f59e0b"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{
                    flexShrink: 0,
                    transform: openFaqs.has(i) ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              <div style={{
                maxHeight: openFaqs.has(i) ? 600 : 0,
                overflow: "hidden",
                transition: "max-height 0.3s ease",
              }}>
                <p style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 14,
                  lineHeight: 1.8,
                  color: "#b8c5d6",
                  padding: "0 20px 20px",
                  margin: 0,
                  whiteSpace: "pre-line",
                }}>
                  {faq.a}
                </p>
              </div>
            </div>
          ))}

          {/* FAQ contact + CTA */}
          <div style={{
            textAlign: "center",
            marginTop: 40,
            padding: "32px 20px",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 16,
            background: "rgba(255,255,255,0.02)",
          }}>
            <p style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 16,
              color: "#b0bdd0",
              lineHeight: 1.7,
              margin: "0 0 8px",
            }}>
              Hai altre domande? Scrivimi al{" "}
              <span style={{ color: "#f59e0b", fontWeight: 600 }}>3207218062</span>
              {" "}o a{" "}
              <a href="mailto:nicola.iantomasi@yimp.it" style={{ color: "#f59e0b", textDecoration: "none", fontWeight: 600 }}>nicola.iantomasi@yimp.it</a>
            </p>
            <p style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 16,
              color: "#e2e8f0",
              fontWeight: 600,
              marginBottom: 24,
            }}>
              Altrimenti, clicca qui in basso per iniziare!
            </p>
            <a
              href="https://www.patreon.com/checkout/nicolaiantomasi?rid=8101904"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-btn"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                padding: "16px 44px",
                background: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
                color: "#fff",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 16,
                fontWeight: 700,
                borderRadius: 50,
                textDecoration: "none",
                letterSpacing: 0.5,
                boxShadow: "0 4px 24px rgba(244,63,94,0.35)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                border: "none",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
                e.currentTarget.style.boxShadow = "0 8px 40px rgba(244,63,94,0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0) scale(1)";
                e.currentTarget.style.boxShadow = "0 4px 24px rgba(244,63,94,0.35)";
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14.82 2.41c3.96 0 7.18 3.24 7.18 7.21 0 3.96-3.22 7.18-7.18 7.18H9.04V2.41h5.78zm-3.78 2v10.39h3.78c2.85 0 5.18-2.32 5.18-5.18 0-2.87-2.33-5.21-5.18-5.21h-3.78zM2 2.41h5.04v14.39H2V2.41z"/>
              </svg>
              Iscriviti ora su Patreon
            </a>
            <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#b0bdd0", marginTop: 10 }}>Accedi a soli 14,99€ al mese e disdici quando vuoi.</div>
          </div>
        </div>

        {/* Legal footer */}
        <div style={{
          textAlign: "center",
          padding: "24px 20px 32px",
          borderTop: "1px solid rgba(255,255,255,0.04)",
        }}>
          <div style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 12,
            color: "#7a8ba3",
            lineHeight: 1.8,
          }}>
            © {new Date().getFullYear()} Yimp di Iantomasi Nicola | P.IVA: 12043750012 | PEC: yimp@pec.it | Telefono: 3207218062 | Email: nicola.iantomasi@yimp.it
          </div>
          <div style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 12,
            color: "#7a8ba3",
            marginTop: 8,
            display: "flex",
            justifyContent: "center",
            gap: 20,
            flexWrap: "wrap",
          }}>
            <a href="https://www.yimp.it/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ color: "#8b9ab8", textDecoration: "none", transition: "color 0.2s" }} onMouseEnter={(e) => e.currentTarget.style.color = "#94a3b8"} onMouseLeave={(e) => e.currentTarget.style.color = "#8b9ab8"}>Privacy Policy</a>
            <a href="https://www.yimp.it/cookie-policy/" target="_blank" rel="noopener noreferrer" style={{ color: "#8b9ab8", textDecoration: "none", transition: "color 0.2s" }} onMouseEnter={(e) => e.currentTarget.style.color = "#94a3b8"} onMouseLeave={(e) => e.currentTarget.style.color = "#8b9ab8"}>Cookie Policy</a>
          </div>
        </div>
      </div>

      {cookieConsent === null && (
        <CookieBanner onAccept={handleCookieAccept} onDecline={handleCookieDecline} />
      )}

      <style>{`
        * { box-sizing: border-box; margin: 0; scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.55) rgba(255,255,255,0.1); }
        html { overflow-y: scroll; }
        ::-webkit-scrollbar { width: 10px; }
        ::-webkit-scrollbar-track { background: rgba(255,255,255,0.1); border-radius: 5px; }
        ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.55); border-radius: 5px; min-height: 40px; }
        ::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.7); }
        @media (min-width: 768px) {
          html { overflow-y: scroll !important; }
        }
        ::placeholder { color: #475569; }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-15px); }
          to { opacity: 1; transform: translateY(0); }
        }
@keyframes pulseGlow {
          0%, 100% { box-shadow: 0 4px 24px rgba(244,63,94,0.35), 0 1px 3px rgba(0,0,0,0.3); }
          50% { box-shadow: 0 4px 36px rgba(244,63,94,0.55), 0 1px 3px rgba(0,0,0,0.3); }
        }
        @keyframes titleGlow {
          0%, 100% { filter: drop-shadow(0 0 20px rgba(245,158,11,0.2)); }
          50% { filter: drop-shadow(0 0 40px rgba(245,158,11,0.4)); }
        }
        .hero-title { animation: fadeInUp 0.8s ease 0.2s both, titleGlow 4s ease-in-out infinite !important; }
        .cta-btn { animation: pulseGlow 3s ease-in-out infinite; }
        @media (max-width: 768px) {
          div[style*="grid-template-columns"] {
            grid-template-columns: 1fr !important;
            padding-bottom: 48px !important;
          }
        }
        .sidebar-scroll { scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.35) rgba(255,255,255,0.08); }
        .sidebar-scroll::-webkit-scrollbar { width: 8px; }
        .sidebar-scroll::-webkit-scrollbar-track { background: rgba(255,255,255,0.08); border-radius: 4px; }
        .sidebar-scroll::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.35); border-radius: 4px; min-height: 40px; }
        .sidebar-scroll::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.5); }
        .footer-cta-photo { display: none; }
        .mobile-only-br { display: none; }
        .mobile-only-br-subtitle { display: none; }
        .desktop-only-br { display: inline; }
        .hero-description { max-width: 800px !important; }
        .mobile-only-btn { display: none; }
        .macro-section-plus::after { content: none; }
        @media (max-width: 768px) {
          .mobile-only-br { display: inline !important; }
          .mobile-only-br-subtitle { display: inline !important; }
          .desktop-only-br { display: none !important; }
          .hero-description { max-width: 750px !important; }
          .hero-subtitle-dash { display: none !important; }
          .hero-subtitle { font-size: 12px !important; letter-spacing: 2px !important; }
          .hero-header > div:first-child { display: none !important; }
          .footer-cta-photo { display: block !important; }
          .footer-cta-photo img { width: 130px !important; height: 130px !important; }
          .mobile-only-btn { display: none !important; }
          .hero-header { padding: 42px 24px 40px !important; }
          .hero-header .hero-subtitle { margin-bottom: 22px !important; }
          .hero-header .hero-title { margin-bottom: 6px !important; }
          .hero-header p { margin-top: 18px !important; }
          .hero-header .cta-btn { margin-top: 40px !important; }
          .stats-bar { padding: 24px 18px 28px !important; }
          .aree-label { font-size: 14px !important; letter-spacing: 2px !important; color: #94a3b8 !important; margin-bottom: 6px !important; }
          .aree-hint { font-size: 13px !important; color: #f59e0b !important; margin-bottom: 20px !important; }
          .macro-section-wrapper { border: 1px solid rgba(255,255,255,0.08) !important; border-radius: 12px !important; margin-bottom: 6px !important; background: rgba(255,255,255,0.02) !important; }
          .macro-section-active { border-color: rgba(255,255,255,0.15) !important; }
          .macro-section-active > div:first-child { border: none !important; }
          .macro-section-plus { width: 28px !important; height: 28px !important; border-radius: 50% !important; background: rgba(245,158,11,0.15) !important; border: 1.5px solid #f59e0b !important; box-shadow: 0 0 8px rgba(245,158,11,0.25) !important; display: flex !important; align-items: center !important; justify-content: center !important; }
          .macro-section-plus::after { content: '+' !important; display: block !important; color: #f59e0b; font-size: 18px; font-weight: 700; line-height: 1; }
          .macro-section-active .macro-section-plus::after { content: '−' !important; }
          .mobile-inline-collections { display: block !important; }
          .desktop-content-area { display: none !important; }
          .content-section-header { pointer-events: none !important; margin-bottom: 20px !important; }
          .content-section-header h2 { color: #64748b !important; }
          .content-section-header + div[style*="height: 3"] { display: none !important; }
          .mobile-back-wrapper { padding-top: 0px !important; }
          .mobile-back-wrapper > div:first-child { margin-top: 0 !important; }
          .neural-bg { display: none !important; }
          .review-img-desktop { display: none !important; }
          .review-img-mobile { display: block !important; }
          .sidebar-nav { max-height: none !important; overflow-y: visible !important; position: static !important; }
          .sidebar-scroll::-webkit-scrollbar { display: none !important; }
        }
      `}</style>
    </div>
  );
}

export default Dashboard;
